import { useAppDispatch, useAppSelector } from "features/config/hooks";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import {
  GetCategoryProductsState,
  selectGetCategoryProducts,
} from "features/shop/presentation/slices/get-category-products.slice";
import {
  GetProductDetailsState,
  selectGetProductDetails,
} from "features/shop/presentation/slices/get-product-details.slice";
import {
  FacebookLoginState,
  selectFacebookLogin,
} from "../slices/facebook-login.slice";
import {
  FacebookLoginPointState,
  selectFacebookLoginPoint,
} from "../slices/facebook-login-point.slice";
import {
  selectUploadProofOfPayment,
  UploadProofOfPaymentState,
} from "../slices/upload-proof-of-payment.slice";
import { AddContactState, selectAddContact } from "../slices/add-contact.slice";
import {
  DeleteContactState,
  selectDeleteContact,
} from "../slices/delete-contact.slice";
import {
  selectUpdateContact,
  UpdateContactState,
} from "../slices/update-contact.slice";
import {
  GetStoresAvailableSnackshopState,
  selectGetStoresAvailableSnackshop,
} from "features/shop/presentation/slices/get-stores-available-snackshop.slice";
import { BackdropLoading } from "./backdrop-loading.wrapper";
import {
  GetStoresAvailableCateringState,
  selectGetStoresAvailableCatering,
} from "features/catering/presentation/slices/get-stores-available-catering.slice";
import {
  AddToCartShopState,
  selectAddToCartShop,
} from "features/shop/presentation/slices/add-to-cart-shop.slice";
import { SnackbarAlert } from "../components/snackbar-alert";
import {
  popOutSnackBar,
  PopSnackBarState,
  selectPopSnackBar,
} from "../slices/pop-snackbar.slice";
import {
  RemoveItemFromCartShopState,
  selectRemoveItemFromCartShop,
} from "features/shop/presentation/slices/remove-item-from-cart-shop.slice";
import {
  AddToCartCateringState,
  selectAddToCartCatering,
} from "features/catering/presentation/slices/add-to-cart-catering.slice";
import {
  CheckoutOrdersState,
  selectCheckoutOrders,
} from "features/shop/presentation/slices/checkout-orders.slice";
import {
  CateringCheckoutOrdersState,
  selectCateringCheckoutOrders,
} from "features/catering/presentation/slices/catering-checkout-orders.slice";
import {
  selectUploadContract,
  UploadContractState,
} from "features/catering/presentation/slices/upload-contract.slice";
import {
  CateringUploadProofOfPaymentState,
  selectCateringUploadProofOfPayment,
} from "features/catering/presentation/slices/catering-upload-proof-of-payment.slice";
import {
  selectSignInMobileUser,
  SignInMobileUserState,
} from "../slices/sign-in-mobile-user.slice";
import { BackdropLoadingPopClub } from "features/popclub/presentation/components";
import {
  GetSnacksDeliveredAvailableStoresState,
  selectGetSnacksDeliveredAvailableStores,
} from "features/popclub/presentation/slices/get-snacks-delivered-available-stores.slice";
import {
  GetDealsState,
  selectGetDeals,
} from "features/popclub/presentation/slices/get-deals.slice";
import {
  selectSetSnacksDeliveredStoreAndAddress,
  SetSnacksDeliveredStoreAndAddressState,
} from "features/popclub/presentation/slices/set-snacks-delivered-store-and-address.slice";
import {
  RedeemDealState,
  selectRedeemDeal,
} from "features/popclub/presentation/slices/redeem-deal.slice";
import {
  selectSignUpMobileUser,
  SignUpMobileUserState,
} from "../slices/sign-up-mobile-user.slice";
import {
  ForgotPasswordGenerateOTPState,
  selectForgotPasswordGenerateOTP,
} from "../slices/forgot-password-generate-otp.slice";
import {
  ForgotPasswordValidateOTPState,
  selectForgotPasswordValidateOTP,
} from "../slices/forgot-password-validate-otp.slice";
import {
  ForgotPasswordNewPasswordState,
  selectForgotPasswordNewPassword,
} from "../slices/forgot-password-new-password-otp.slice";
import {
  GetDealState,
  selectGetDeal,
} from "features/popclub/presentation/slices/get-deal.slice";
import {
  GetDealProductVariantsState,
  selectGetDealProductVariants,
} from "features/popclub/presentation/slices/get-deal-product-variants.slice";
import {
  GetRedeemState,
  selectGetRedeem,
} from "features/popclub/presentation/slices/get-redeem.slice";
import {
  EditCartItemState,
  selectEditCartItem,
} from "features/shop/presentation/slices/edit-cart-item.slice";
import {
  GetAdminShopOrdersState,
  selectGetAdminShopOrders,
} from "features/admin/presentation/slices/get-admin-shop-orders.slice";
import {
  GetAdminShopOrderState,
  selectGetAdminShopOrder,
} from "features/admin/presentation/slices/get-admin-shop-order.slice";
import {
  LoginAdminState,
  selectLoginAdmin,
} from "features/admin/presentation/slices/login-admin.slice";
import {
  GetAdminPopclubRedeemState,
  selectGetAdminPopclubRedeem,
} from "features/admin/presentation/slices/get-admin-popclub-redeem.slice";
import {
  GetAdminUsersState,
  selectGetAdminUsers,
} from "features/admin/presentation/slices/get-admin-users.slice";
import {
  CreateAdminUserState,
  selectCreateAdminUser,
} from "features/admin/presentation/slices/create-admin-user.slice";
import {
  GetAdminUserState,
  selectGetAdminUser,
} from "features/admin/presentation/slices/get-admin-user.slice";
import {
  GetAdminGroupsState,
  selectGetAdminGroups,
} from "features/admin/presentation/slices/get-admin-groups.slice";
import {
  EditAdminUserState,
  selectEditAdminUser,
} from "features/admin/presentation/slices/edit-admin-user.slice";
import {
  GetAdminSettingUserStoreState,
  selectGetAdminSettingUserStore,
} from "features/admin/presentation/slices/get-admin-setting-user-store.slice";
import {
  GetAdminSettingUserStoresState,
  selectGetAdminSettingUserStores,
} from "features/admin/presentation/slices/get-admin-setting-user-stores.slice";
import {
  selectUpdateAdminSettingUserStores,
  UpdateAdminSettingUserStoresState,
} from "features/admin/presentation/slices/update-admin-setting-user-stores.slice";
import {
  CreateAdminGroupState,
  selectCreateAdminGroup,
} from "features/admin/presentation/slices/create-admin-group.slice";
import {
  selectUploadProofOfPaymentAdmin,
  UploadProofOfPaymentAdminState,
} from "features/admin/presentation/slices/upload-proof-of-payment-admin.slice";
import {
  selectValidateReferenceNumberAdmin,
  ValidateReferenceNumberAdminState,
} from "features/admin/presentation/slices/validate-reference-number.slice";
import {
  AdminShopOrderUpdateStatusState,
  selectAdminShopOrderUpdateStatus,
} from "features/admin/presentation/slices/admin-shop-order-update-status.slice";
import {
  AdminPrivilegeState,
  selectAdminPrivilege,
} from "features/admin/presentation/slices/admin-privilege.slice";
import {
  AdminCateringBookingUpdateStatusState,
  selectAdminCateringBookingUpdateStatus,
} from "features/admin/presentation/slices/admin-catering-booking-update-status.slice";
import {
  selectUpdateStoreDeal,
  UpdateStoreDealState,
} from "features/admin/presentation/slices/update-store-deal.slice";
import {
  AdminDeclineRedeemState,
  selectAdminDeclineRedeem,
} from "features/admin/presentation/slices/admin-decline-redeem.slice";
import {
  GetAdminSettingStoresState,
  selectGetAdminSettingStores,
} from "features/admin/presentation/slices/get-admin-setting-stores.slice";
import {
  selectUpdateStoreProduct,
  UpdateStoreProductState,
} from "features/admin/presentation/slices/update-store-product.slice";
import {
  selectUpdateStoreCatersPackage,
  UpdateStoreCatersPackageState,
} from "features/admin/presentation/slices/update-store-caters-packages.slice";
import {
  selectUpdateStoreCatersPackageAddon,
  UpdateStoreCatersPackageAddonState,
} from "features/admin/presentation/slices/update-store-caters-package-addons.slice";
import {
  selectUpdateStoreCatersProductAddon,
  UpdateStoreCatersProductAddonState,
} from "features/admin/presentation/slices/update-store-caters-product-addons.slice";
import {
  AdminCateringPrivilegeState,
  selectAdminCateringPrivilege,
} from "features/admin/presentation/slices/admin-catering-privilege.slice";
import {
  ApplyUserDiscountState,
  selectApplyUserDiscount,
} from "features/profile/presentation/slices/apply-user-discount.slice";
import {
  AdminUserDiscountChangeStatusState,
  selectAdminUserDiscountChangeStatus,
} from "features/admin/presentation/slices/admin-user-discount-change-status.slice";
import {
  selectUpdateUserDiscount,
  UpdateUserDiscountState,
} from "features/profile/presentation/slices/update-user-discount.slice";
import {
  LoginBscState,
  selectLoginBsc,
} from "features/bsc/presentation/slices/login-bsc.slice";
import {
  CreateBscUserState,
  selectCreateBscUser,
} from "features/bsc/presentation/slices/create-bsc-user.slice";
import {
  selectUpdateBscUserStatus,
  UpdateBscUserStatusState,
} from "features/bsc/presentation/slices/update-bsc-user-status.slice";
import {
  selectUpdateBscUser,
  UpdateBscUserState,
} from "features/bsc/presentation/slices/bsc-update-user.slice";
import {
  GetStoresAvailableSnackshopModalState,
  selectGetStoresAvailableSnackshopModal,
} from "features/shop/presentation/slices/get-stores-available-snackshop-modal.slice";
import {
  GetStoresAvailableCateringModalState,
  selectGetStoresAvailableCateringModal,
} from "features/catering/presentation/slices/get-stores-available-catering-modal.slice";
import {
  InsertCustomerSurveyResponseState,
  selectInsertCustomerSurveyResponse,
} from "features/survey/presentation/slices/insert-customer-survey-response.slice";
import {
  CreateAdminSettingShopProductState,
  selectCreateAdminSettingShopProduct,
} from "features/admin/presentation/slices/create-admin-setting-shop-product.slice";
import {
  EditAdminSettingShopProductState,
  selectEditAdminSettingShopProduct,
} from "features/admin/presentation/slices/edit-admin-setting-shop-product.slice";
import {
  DeleteAdminSettingShopProductState,
  selectDeleteAdminSettingShopProduct,
} from "features/admin/presentation/slices/delete-admin-setting-shop-product.slice";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  AddToCartCateringProductState,
  selectAddToCartCateringProduct,
} from "features/catering/presentation/slices/add-to-cart-catering-products.slice";

import {
  selectUpdateAdminCateringOrderItemRemarks,
  UpdateAdminCateringOrderItemRemarksState,
} from "features/admin/presentation/slices/update-admin-catering-order-item-remarks.slice";
import {
  CreateAdminSettingStoreState,
  selectCreateAdminSettingStore,
} from "features/admin/presentation/slices/create-admin-setting-store.slice";
import {
  GetSnacksDeliveredDealAvailableStoresState,
  selectGetSnacksDeliveredDealAvailableStores,
} from "features/popclub/presentation/slices/get-snacks-delivered-deal-available-stores.slice";
import {
  selectSetSnacksDeliveredDealStoreAndAddress,
  SetSnacksDeliveredDealStoreAndAddressState,
} from "features/popclub/presentation/slices/set-snacks-delivered-deal-store-and-address.slice";
import {
  selectSetSnackshopStoreAndAddress,
  SetSnackshopStoreAndAddressState,
} from "features/shop/presentation/slices/set-snackshop-store-and-address.slice";
import {
  selectSetCateringStoreAndAddress,
  SetCateringStoreAndAddressState,
} from "features/catering/presentation/slices/set-catering-store-and-address.slice";
import {
  GetAdminSettingStoreState,
  selectGetAdminSettingStore,
} from "features/admin/presentation/slices/get-admin-setting-store.slice";
import {
  EditAdminSettingStoreState,
  selectEditAdminSettingStore,
} from "features/admin/presentation/slices/edit-admin-setting-store.slice";
import {
  CopyAdminSettingShopProductState,
  selectCopyAdminSettingShopProduct,
} from "features/admin/presentation/slices/copy-admin-setting-shop-product.slice";
import {
  CreateAdminSettingCateringPackageState,
  selectCreateAdminSettingCateringPackage,
} from "features/admin/presentation/slices/create-admin-setting-catering-package.slice";
import {
  EditAdminSettingCateringPackageState,
  selectEditAdminSettingCateringPackage,
} from "features/admin/presentation/slices/edit-admin-setting-catering-package.slice";
import {
  CopyAdminSettingCateringPackageState,
  selectCopyAdminSettingCateringPackage,
} from "features/admin/presentation/slices/copy-admin-setting-catering-package.slice";
import {
  CreateAdminSettingPopclubDealState,
  selectCreateAdminSettingPopclubDeal,
} from "features/admin/presentation/slices/create-admin-setting-popclub-deal.slice";
import {
  ApplyInfluencerState,
  selectApplyInfluencer,
} from "features/profile/presentation/slices/apply-influencer.slice";
import {
  selectUpdateInfluencer,
  UpdateInfluencerState,
} from "features/profile/presentation/slices/update-influencer.slice";
import {
  AdminInfluencerApplicationChangeStatusState,
  selectAdminInfluencerApplicationChangeStatus,
} from "features/admin/presentation/slices/admin-influencer-application-change-status.slice";

import {
  EditAdminSettingPopclubDealState,
  selectEditAdminSettingPopclubDeal,
} from "features/admin/presentation/slices/edit-admin-setting-popclub-deal.slice";
import {
  selectValidatePartnerCompanyEmployeeIdNumberAdmin,
  ValidatePartnerCompanyEmployeeIdNumberAdminState,
} from "features/admin/presentation/slices/validate-partner-company-employee-id-number.slice";

import {
  selectGetSnackshopInfluencerPromo,
  GetSnackshopInfluencerPromoState,
} from "features/shop/presentation/slices/get-snackshop-influencer-promo.slice";
import {
  selectUploadContractInfluencer,
  UploadContractInfluencerState,
} from "features/profile/presentation/slices/upload-contract-influencer.slice";
import {
  CreateAdminInfluencerPromoState,
  selectCreateAdminInfluencerPromo,
} from "features/admin/presentation/slices/create-admin-influencer-promo.slice";
import {
  selectInfluencerCashout,
  InfluencerCashoutState,
} from "features/profile/presentation/slices/influencer-cashout.slice";
import {
  selectAdminInfluencerCashoutChangeStatus,
  AdminInfluencerCashoutChangeStatusState,
} from "features/admin/presentation/slices/admin-influencer-cashout-change-status.slice";
import {
  InsertNewOrderState,
  selectInsertNewOrder,
} from "features/stock-ordering/presentation/slices/insert-new-order.slice";
import {
  selectupdateNewOrders,
  updateNewOrdersState,
} from "features/stock-ordering/presentation/slices/update-new-order.slice";
import {
  selectupdateReviewOrders,
  updateReviewOrdersState,
} from "features/stock-ordering/presentation/slices/update-review-order.slice";

import {
  selectupdateReceiveOrders,
  updateReceiveOrdersState,
} from "features/stock-ordering/presentation/slices/update-receive-order.slice";

import {
  selectUpdateBillingOrders,
  updateBillingOrdersState,
} from "features/stock-ordering/presentation/slices/update-billing-order.slice";
import {
  selectUpdatePayBillingOrders,
  updatePayBillingOrdersState,
} from "features/stock-ordering/presentation/slices/update-pay-billing.slice";
import {
  selectUpdateConfirmPayment,
  updateConfirmPaymentState,
} from "features/stock-ordering/presentation/slices/update-confirm-payment.slice";
import {
  selectUpdateOrderCancelled,
  updateOrderCancelledState,
} from "features/stock-ordering/presentation/slices/update-order-cancelled.slice";
import {
  selectUpdateOrderItems,
  updateOrderItemsState,
} from "features/stock-ordering/presentation/slices/update-order-items.slice";
import {
  selectSubmitKra,
  SubmitKraState,
} from "features/hr/presentation/slices/submit-kra";
import {
  selectUpdateKra,
  UpdateKraState,
} from "features/hr/presentation/slices/update-kra";
import {
  selectUpdateActionItem,
  UpdateActionItemState,
} from "features/hr/presentation/slices/update-action-item";
import {
  selectSubmitAssessment,
  SubmitAssessmentState,
} from "features/hr/presentation/slices/submit-assessment";

import {
  GetStockOrderSettingProductsState,
  selectGetStockOrderSettingProducts,
} from "features/stock-ordering/presentation/slices/stock-order-get-settings-products.slice";
import {
  GetStockOrderSettingProductsEditState,
  selectGetStockOrderSettingProductsEdit,
} from "features/stock-ordering/presentation/slices/stock-order-get-settings-products-edit.slice";
import {
  selectGetStockOrderAllStores,
  GetStockOrderAllStoresState,
} from "features/stock-ordering/presentation/slices/stock-order-get-all-stores.slice";
import {
  selectstockOrderEditProduct,
  stockOrderEditProductState,
} from "features/stock-ordering/presentation/slices/stock-order-settings-product-edit.slice";
import {
  selectstockOrderCreateProduct,
  stockOrderCreateProductState,
} from "features/stock-ordering/presentation/slices/stock-order-settings-product-create.slice";
import {
  selectStockOrderSettingsProductInfoChanges,
  stockOrderSettingsProductInfoChangesState,
} from "features/stock-ordering/presentation/slices/stock-order-settings-product-change-info.slice";
import {
  selectUpdateMinimumTotalAmount,
  UpdateMinimumTotalAmountState,
} from "features/stock-ordering/presentation/slices/update-minimum-total-amount.slice";
import {
  AdminCateringBookingOverrideEventDateState,
  selectAdminCateringBookingOverrideEventDate,
} from "features/admin/presentation/slices/admin-catering-booking-override-event-date.slice";
import {
  AdminCateringBookingApproveOverrideState,
  selectAdminCateringBookingApproveOverride,
} from "features/admin/presentation/slices/admin-catering-booking-approve-override.slice";
import {
  HrImportUsersState,
  selectHrImportUsers,
} from "features/hr/presentation/slices/hr-import-users.slice";
import {
  SaveAssessmentState,
  selectSaveAssessment,
} from "features/hr/presentation/slices/save-assessment.slice";
import {
  selectTeiHubLinkPlaceOrder,
  TeiHubLinkPlaceOrder,
} from "features/hublink/presentation/slices/tei-hub-link-place-order.slice";
import {
  selectTeiHubLinkStoreCancelOrder,
  TeiHubLinkStoreCancelOrder,
} from "features/hublink/presentation/slices/tei-hub-link-store-cancel-order.slice";
import {
  selectTeiHubLinkModifyOrder,
  TeiHubLinkModifyOrder,
} from "features/hublink/presentation/slices/tei-hub-link-modify-order.slice";
import {
  selectTeiHubLinkAcceptOrder,
  TeiHubLinkAcceptOrder,
} from "features/hublink/presentation/slices/tei-hub-link-accept-order.slice";
import {
  selectTeiHubLinkDispatchOrder,
  TeiHubLinkDispatchOrder,
} from "features/hublink/presentation/slices/tei-hub-link-dispatch-order.slice";
import {
  selectTeiHubLinkLogisticReceiveOrder,
  TeiHubLinkLogisticReceiveOrder,
} from "features/hublink/presentation/slices/tei-hub-link-logistic-receive.slice";
import {
  selectTeiHubLinkReceiveOrder,
  TeiHubLinkReceiveOrder,
} from "features/hublink/presentation/slices/tei-hub-link-receive-order.slice";
import {
  selectTeiHubLinkCompleteOrder,
  TeiHubLinkCompleteOrder,
} from "features/hublink/presentation/slices/tei-hub-link-complete-order.slice";
import {
  selectTeiHubLinkReturnRefund,
  TeiHubLinkReturnRefund,
} from "features/hublink/presentation/slices/tei-hub-link-return-refund.slice";
import {
  selectTeiHubLinkDispatchMultiple,
  TeiHubLinkDispatchMultiple,
} from "features/hublink/presentation/slices/tei-hub-link-dispatch-multiple-orders.slice";
import {
  selectTeiHubLinkCreateStore,
  TeiHubLinkCreateStoreState,
} from "features/hublink/presentation/slices/tei-hub-link-store-enrollment.slice";
import {
  selectTeiHubLinkCreateUser,
  TeiHubLinkCreateUserState,
} from "features/hublink/presentation/slices/tei-hub-link-create-user-param.slice";

import {
  selectUpdateCommitedDelivery,
  updateCommitedDeliveryState,
} from "features/stock-ordering/presentation/slices/update-commited-delivery.slice";
import {
  InsertNewProductCostState,
  selectinsertNewProductCost,
} from "features/stock-ordering/presentation/slices/insert-new-product-cost.slice";
import {
  AdminSettingsUpdateStoreBranchStatusState,
  selectAdminSettingsUpdateStoreBranchStatus,
} from "features/admin/presentation/slices/admin-settings-update-store-branch-status.slice";
import {
  AdminInserStoreCreationNewRegionState,
  selectAdminInserStoreCreationNewRegion,
} from "features/admin/presentation/slices/admin-insert-store-creation-new-region.slice";
import {
  selectFormList,
  formListState,
} from "features/ms6/presentation/slices/form-list.slice";
import {
  selectStockDispatchOrders,
  StockDispatchOrdersState,
} from "features/stock-ordering/presentation/slices/stock-dispatch-order.slice";
import {
  selectStockInitialOrderReview,
  StockInitialOrderReviewState,
} from "features/stock-ordering/presentation/slices/stock-initial-order-review.slice";
import {
  selectStockDeliveryApproval,
  StockDeliveryApprovalState,
} from "features/stock-ordering/presentation/slices/stock-delivery-approval.slice";
import {
  selectUpdatedSalesInvoiceApproval,
  UpdatedSalesInvoiceApprovalState,
} from "features/stock-ordering/presentation/slices/updated-sales-invoice-approval.slice";
import {
  selectstaggeredReceive,
  staggeredReceiveState,
} from "features/stock-ordering/presentation/slices/staggered-receive.slice";
import {
  selectstaggeredDispatch,
  staggeredDispatchState,
} from "features/stock-ordering/presentation/slices/staggered-dispatch.slice";

Swal.mixin({
  background: "#22201A",
  color: "white",
});

const SweetAlert = withReactContent(Swal);

export function LoadingAndSnackbarWrapper() {
  const [openBackdropLoading, setOpenBackdropLoading] = useState(false);
  const [openBackdropPopClubLoading, setOpenBackdropPopClubLoading] =
    useState(false);
  const [successAlert, setSuccessAlert] = useState<{
    status: boolean;
    message?: string;
  }>({
    status: false,
  });

  const [failsAlert, setFailsAlert] = useState<{
    status: boolean;
    message?: string;
  }>({
    status: false,
  });

  const dispatch = useAppDispatch();

  const getStoresAvailableSnackshopState = useAppSelector(
    selectGetStoresAvailableSnackshop
  );
  const getCategoryProductsState = useAppSelector(selectGetCategoryProducts);
  const getProductDetailsState = useAppSelector(selectGetProductDetails);
  const setSnackshopStoreAndAddressState = useAppSelector(
    selectSetSnackshopStoreAndAddress
  );
  const setCateringStoreAndAddressState = useAppSelector(
    selectSetCateringStoreAndAddress
  );
  const addToCartShopState = useAppSelector(selectAddToCartShop);
  const facebookLoginState = useAppSelector(selectFacebookLogin);
  const facebookLoginPointState = useAppSelector(selectFacebookLoginPoint);
  const removeItemFromCartShopState = useAppSelector(
    selectRemoveItemFromCartShop
  );
  const uploadProofOfPaymentState = useAppSelector(selectUploadProofOfPayment);
  const addContactState = useAppSelector(selectAddContact);
  const deleteContactState = useAppSelector(selectDeleteContact);
  const updateContactState = useAppSelector(selectUpdateContact);
  const getStoresAvailableCateringState = useAppSelector(
    selectGetStoresAvailableCatering
  );
  const popSnackBarState = useAppSelector(selectPopSnackBar);
  const addToCartCateringState = useAppSelector(selectAddToCartCatering);
  const checkoutOrdersState = useAppSelector(selectCheckoutOrders);
  const cateringCheckoutOrdersState = useAppSelector(
    selectCateringCheckoutOrders
  );
  const uploadContractState = useAppSelector(selectUploadContract);
  const cateringUploadProofOfPaymentState = useAppSelector(
    selectCateringUploadProofOfPayment
  );
  const signInMobileUserState = useAppSelector(selectSignInMobileUser);
  const getSnacksDeliveredAvailableStoresState = useAppSelector(
    selectGetSnacksDeliveredAvailableStores
  );
  const getDealsState = useAppSelector(selectGetDeals);
  const setSnacksDeliveredStoreAndAddress = useAppSelector(
    selectSetSnacksDeliveredStoreAndAddress
  );
  const redeemDealState = useAppSelector(selectRedeemDeal);
  const signUpMobileUserState = useAppSelector(selectSignUpMobileUser);
  const forgotPasswordGenerateOTP = useAppSelector(
    selectForgotPasswordGenerateOTP
  );
  const forgotPasswordValidateOTP = useAppSelector(
    selectForgotPasswordValidateOTP
  );
  const forgotPasswordNewPasswordOTP = useAppSelector(
    selectForgotPasswordNewPassword
  );
  const getDealState = useAppSelector(selectGetDeal);
  const getDealProductVariantsState = useAppSelector(
    selectGetDealProductVariants
  );
  const getRedeemState = useAppSelector(selectGetRedeem);
  const editCartProduct = useAppSelector(selectEditCartItem);
  const getAdminShopOrdersState = useAppSelector(selectGetAdminShopOrders);
  const getAdminShopOrderState = useAppSelector(selectGetAdminShopOrder);
  const loginAdminState = useAppSelector(selectLoginAdmin);
  const getAdminPopclubRedeemState = useAppSelector(
    selectGetAdminPopclubRedeem
  );

  const getAdminUsersState = useAppSelector(selectGetAdminUsers);
  const createAdminUserState = useAppSelector(selectCreateAdminUser);
  const editAdminUserState = useAppSelector(selectEditAdminUser);
  const getAdminUserState = useAppSelector(selectGetAdminUser);
  const getAdminGroupsState = useAppSelector(selectGetAdminGroups);
  const getAdminSettingUserStoreState = useAppSelector(
    selectGetAdminSettingUserStore
  );
  const getAdminSettingUserStoresState = useAppSelector(
    selectGetAdminSettingUserStores
  );
  const updateAdminSettingUserStores = useAppSelector(
    selectUpdateAdminSettingUserStores
  );
  const createAdminGroupState = useAppSelector(selectCreateAdminGroup);
  const uploadProofOfPaymentAdminState = useAppSelector(
    selectUploadProofOfPaymentAdmin
  );
  const validateReferenceNumberAdminState = useAppSelector(
    selectValidateReferenceNumberAdmin
  );
  const adminShopOrderUpdateStatusState = useAppSelector(
    selectAdminShopOrderUpdateStatus
  );
  const adminPrivilegeState = useAppSelector(selectAdminPrivilege);

  const adminCateringBookingUpdateStatusState = useAppSelector(
    selectAdminCateringBookingUpdateStatus
  );

  const updateStoreDealState = useAppSelector(selectUpdateStoreDeal);

  const adminDeclineRedeemState = useAppSelector(selectAdminDeclineRedeem);

  const getAdminSettingStoresState = useAppSelector(
    selectGetAdminSettingStores
  );
  const updateStoreProductState = useAppSelector(selectUpdateStoreProduct);
  const updateStoreCatersPackageState = useAppSelector(
    selectUpdateStoreCatersPackage
  );
  const updateStoreCatersPackageAddonState = useAppSelector(
    selectUpdateStoreCatersPackageAddon
  );
  const updateStoreCatersProductAddonState = useAppSelector(
    selectUpdateStoreCatersProductAddon
  );

  const adminCateringPrivilegeState = useAppSelector(
    selectAdminCateringPrivilege
  );

  const applyUserDiscountState = useAppSelector(selectApplyUserDiscount);

  const adminUserDiscountChangeStatusState = useAppSelector(
    selectAdminUserDiscountChangeStatus
  );

  const updateUserDiscountState = useAppSelector(selectUpdateUserDiscount);

  const loginBscState = useAppSelector(selectLoginBsc);

  const createBscUserState = useAppSelector(selectCreateBscUser);

  const updateBscUserStatusState = useAppSelector(selectUpdateBscUserStatus);

  const updateBscUserState = useAppSelector(selectUpdateBscUser);

  const getStoresAvailableSnackshopModalState = useAppSelector(
    selectGetStoresAvailableSnackshopModal
  );
  const getStoresAvailableCateringModalState = useAppSelector(
    selectGetStoresAvailableCateringModal
  );
  const addToCartCateringProductState = useAppSelector(
    selectAddToCartCateringProduct
  );

  const updateAdminCateringOrderItemRemarksState = useAppSelector(
    selectUpdateAdminCateringOrderItemRemarks
  );
  const createAdminSettingStoreState = useAppSelector(
    selectCreateAdminSettingStore
  );

  const getAdminSettingStoreState = useAppSelector(selectGetAdminSettingStore);
  const editAdminSettingStoreState = useAppSelector(
    selectEditAdminSettingStore
  );

  const copyAdminSettingShopProductState = useAppSelector(
    selectCopyAdminSettingShopProduct
  );
  const createAdminSettingCateringPackageState = useAppSelector(
    selectCreateAdminSettingCateringPackage
  );
  const editAdminSettingCateringPackageState = useAppSelector(
    selectEditAdminSettingCateringPackage
  );
  const copyAdminSettingCateringPackageState = useAppSelector(
    selectCopyAdminSettingCateringPackage
  );
  const createAdminSettingPopclubDealState = useAppSelector(
    selectCreateAdminSettingPopclubDeal
  );
  const applyInfluencerState = useAppSelector(selectApplyInfluencer);
  const updateInfluencerState = useAppSelector(selectUpdateInfluencer);
  const adminInfluencerApplicationChangeStatusState = useAppSelector(
    selectAdminInfluencerApplicationChangeStatus
  );
  const editAdminSettingPopclubDealState = useAppSelector(
    selectEditAdminSettingPopclubDeal
  );
  const getSnackshopInfluencerPromoState = useAppSelector(
    selectGetSnackshopInfluencerPromo
  );

  const uploadContractInfluencerState = useAppSelector(
    selectUploadContractInfluencer
  );
  const createAdminInfluencerPromoState = useAppSelector(
    selectCreateAdminInfluencerPromo
  );
  const influencerCashoutState = useAppSelector(selectInfluencerCashout);

  const adminInfluencerCashoutChangeStatusState = useAppSelector(
    selectAdminInfluencerCashoutChangeStatus
  );

  const validatePartnerCompanyEmployeeIdNumberAdminState = useAppSelector(
    selectValidatePartnerCompanyEmployeeIdNumberAdmin
  );

  const insertStockOrderingNewOrder = useAppSelector(selectInsertNewOrder);
  const updateStockOrderNewOrder = useAppSelector(selectupdateNewOrders);
  const stockUpdateReviewOrderState = useAppSelector(selectupdateReviewOrders);
  const stockDispatchOrderState = useAppSelector(selectStockDispatchOrders);
  const stockUpdateReceiveOrderState = useAppSelector(
    selectupdateReceiveOrders
  );
  const stockDeliveryApprovalState = useAppSelector(
    selectStockDeliveryApproval
  );
  const stockUpdateBillingOrderState = useAppSelector(
    selectUpdateBillingOrders
  );
  const stockUpdatePayBillingOrderState = useAppSelector(
    selectUpdatePayBillingOrders
  );
  const stockUpdateConfirmPaymentState = useAppSelector(
    selectUpdateConfirmPayment
  );
  const stockCancelOrder = useAppSelector(selectUpdateOrderCancelled);

  const stockUpdateOrderItems = useAppSelector(selectUpdateOrderItems);

  const submitKraState = useAppSelector(selectSubmitKra);

  const updateKraState = useAppSelector(selectUpdateKra);

  const updateActionItemState = useAppSelector(selectUpdateActionItem);
  const submitAssessmentState = useAppSelector(selectSubmitAssessment);

  const getStockOrderSettingProducts = useAppSelector(
    selectGetStockOrderSettingProducts
  );

  const getStockOrderSettingProductsEditState = useAppSelector(
    selectGetStockOrderSettingProductsEdit
  );

  const getStockOrderAllStoresState = useAppSelector(
    selectGetStockOrderAllStores
  );

  const stockOrderEditProductStates = useAppSelector(
    selectstockOrderEditProduct
  );

  const stockOrderCreateProductStates = useAppSelector(
    selectstockOrderCreateProduct
  );

  const stockOrderSettingsProductChange = useAppSelector(
    selectStockOrderSettingsProductInfoChanges
  );

  const updateMinimumTotalAmountState = useAppSelector(
    selectUpdateMinimumTotalAmount
  );

  useEffect(() => {
    switch (updateMinimumTotalAmountState.status) {
      case UpdateMinimumTotalAmountState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateMinimumTotalAmountState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateMinimumTotalAmountState.success:
        setOpenBackdropLoading(false);
        showAlert(setSuccessAlert, updateMinimumTotalAmountState.message);
        break;
      case UpdateMinimumTotalAmountState.fail:
        showAlert(setFailsAlert, updateMinimumTotalAmountState.message);
        break;
    }
  }, [updateMinimumTotalAmountState]);
  const getSnacksDeliveredDealAvailableStoresState = useAppSelector(
    selectGetSnacksDeliveredDealAvailableStores
  );

  const setSnacksDeliveredDealStoreAndAddressState = useAppSelector(
    selectSetSnacksDeliveredDealStoreAndAddress
  );

  const adminCateringBookingOverrideEventDateState = useAppSelector(
    selectAdminCateringBookingOverrideEventDate
  );

  const adminCateringBookingApproveOverrideState = useAppSelector(
    selectAdminCateringBookingApproveOverride
  );

  const hrImportUsersState = useAppSelector(selectHrImportUsers);

  const saveAssessmentState = useAppSelector(selectSaveAssessment);

  const teiHubLinkPlaceOrder = useAppSelector(selectTeiHubLinkPlaceOrder);

  const teiHubLinkStoreCancelOrderState = useAppSelector(
    selectTeiHubLinkStoreCancelOrder
  );

  const teiHubLinkModifyOrderState = useAppSelector(
    selectTeiHubLinkModifyOrder
  );

  const teiHubLinkAcceptOrderState = useAppSelector(
    selectTeiHubLinkAcceptOrder
  );
  const teiHubLinkDispatchOrderState = useAppSelector(
    selectTeiHubLinkDispatchOrder
  );
  const teiHubLinkLogisticReceiveOrderState = useAppSelector(
    selectTeiHubLinkLogisticReceiveOrder
  );

  const teiHubLinkReceiveOrderState = useAppSelector(
    selectTeiHubLinkReceiveOrder
  );

  const teiHubLinkCompleteOrderState = useAppSelector(
    selectTeiHubLinkCompleteOrder
  );

  const teiHubLinkReturnRefundState = useAppSelector(
    selectTeiHubLinkReturnRefund
  );

  const teiHubLinkDispatchMultiple = useAppSelector(
    selectTeiHubLinkDispatchMultiple
  );

  const teiHubLinkCreateStoreState = useAppSelector(
    selectTeiHubLinkCreateStore
  );

  const teiHubLinkCreateUserState = useAppSelector(selectTeiHubLinkCreateUser);

  const commitedDeliveryState = useAppSelector(selectUpdateCommitedDelivery);

  const insertNewProductCostState = useAppSelector(selectinsertNewProductCost);

  const adminSettingsUpdateStoreBranchStatusState = useAppSelector(
    selectAdminSettingsUpdateStoreBranchStatus
  );
  const formListStates = useAppSelector(selectFormList);

  const adminInserStoreCreationNewRegionState = useAppSelector(
    selectAdminInserStoreCreationNewRegion
  );

  const updatedSalesInvoiceApprovalState = useAppSelector(
    selectUpdatedSalesInvoiceApproval
  );

  const staggeredReceive = useAppSelector(selectstaggeredReceive);

  const staggeredDispatch = useAppSelector(selectstaggeredDispatch);

  useEffect(() => {
    switch (staggeredDispatch.status) {
      case staggeredDispatchState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case staggeredDispatchState.initial:
        setOpenBackdropLoading(false);
        break;
      case staggeredDispatchState.success:
        showAlert(setSuccessAlert, staggeredDispatch.message);
        setOpenBackdropLoading(false);
        break;
      case staggeredDispatchState.fail:
        showAlert(setFailsAlert, staggeredDispatch.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [staggeredDispatch]);

  useEffect(() => {
    switch (staggeredReceive.status) {
      case staggeredReceiveState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case staggeredReceiveState.initial:
        setOpenBackdropLoading(false);
        break;
      case staggeredReceiveState.success:
        showAlert(setSuccessAlert, staggeredReceive.message);
        setOpenBackdropLoading(false);
        break;
      case staggeredReceiveState.fail:
        showAlert(setFailsAlert, staggeredReceive.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [staggeredReceive]);

  useEffect(() => {
    switch (updatedSalesInvoiceApprovalState.status) {
      case UpdatedSalesInvoiceApprovalState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdatedSalesInvoiceApprovalState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdatedSalesInvoiceApprovalState.success:
        showAlert(setSuccessAlert, updatedSalesInvoiceApprovalState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdatedSalesInvoiceApprovalState.fail:
        showAlert(setFailsAlert, updatedSalesInvoiceApprovalState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updatedSalesInvoiceApprovalState]);

  const stockInitialOrderReview = useAppSelector(selectStockInitialOrderReview);

  useEffect(() => {
    switch (stockInitialOrderReview.status) {
      case StockInitialOrderReviewState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case StockInitialOrderReviewState.initial:
        setOpenBackdropLoading(false);
        break;
      case StockInitialOrderReviewState.success:
        showAlert(setSuccessAlert, stockInitialOrderReview.message);
        setOpenBackdropLoading(false);
        break;
      case StockInitialOrderReviewState.fail:
        showAlert(setFailsAlert, stockInitialOrderReview.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [stockInitialOrderReview]);

  useEffect(() => {
    switch (adminInserStoreCreationNewRegionState.status) {
      case AdminInserStoreCreationNewRegionState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AdminInserStoreCreationNewRegionState.initial:
        setOpenBackdropLoading(false);
        break;
      case AdminInserStoreCreationNewRegionState.success:
        showAlert(
          setSuccessAlert,
          adminInserStoreCreationNewRegionState.message
        );
        setOpenBackdropLoading(false);
        break;
      case AdminInserStoreCreationNewRegionState.fail:
        showAlert(setFailsAlert, adminInserStoreCreationNewRegionState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [adminInserStoreCreationNewRegionState]);

  useEffect(() => {
    switch (adminSettingsUpdateStoreBranchStatusState.status) {
      case AdminSettingsUpdateStoreBranchStatusState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AdminSettingsUpdateStoreBranchStatusState.initial:
        setOpenBackdropLoading(false);
        break;
      case AdminSettingsUpdateStoreBranchStatusState.success:
        showAlert(
          setSuccessAlert,
          adminSettingsUpdateStoreBranchStatusState.message
        );
        setOpenBackdropLoading(false);
        break;
      case AdminSettingsUpdateStoreBranchStatusState.fail:
        showAlert(
          setFailsAlert,
          adminSettingsUpdateStoreBranchStatusState.message
        );
        setOpenBackdropLoading(false);
        break;
    }
  }, [adminSettingsUpdateStoreBranchStatusState]);

  useEffect(() => {
    switch (insertNewProductCostState.status) {
      case InsertNewProductCostState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case InsertNewProductCostState.initial:
        setOpenBackdropLoading(false);
        break;
      case InsertNewProductCostState.success:
        showAlert(setSuccessAlert, insertNewProductCostState.message);
        setOpenBackdropLoading(false);
        break;
      case InsertNewProductCostState.fail:
        showAlert(setFailsAlert, insertNewProductCostState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [insertNewProductCostState]);

  useEffect(() => {
    switch (commitedDeliveryState.status) {
      case updateCommitedDeliveryState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case updateCommitedDeliveryState.initial:
        setOpenBackdropLoading(false);
        break;
      case updateCommitedDeliveryState.success:
        showAlert(setSuccessAlert, commitedDeliveryState.message);
        setOpenBackdropLoading(false);
        break;
      case updateCommitedDeliveryState.fail:
        showAlert(setFailsAlert, commitedDeliveryState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [commitedDeliveryState]);

  useEffect(() => {
    switch (teiHubLinkCreateUserState.status) {
      case TeiHubLinkCreateUserState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case TeiHubLinkCreateUserState.initial:
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkCreateUserState.success:
        showAlert(setSuccessAlert, teiHubLinkCreateUserState.message);
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkCreateUserState.fail:
        showAlert(setFailsAlert, teiHubLinkCreateUserState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [teiHubLinkCreateUserState]);

  useEffect(() => {
    switch (teiHubLinkCreateStoreState.status) {
      case TeiHubLinkCreateStoreState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case TeiHubLinkCreateStoreState.initial:
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkCreateStoreState.success:
        showAlert(setSuccessAlert, teiHubLinkCreateStoreState.message);
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkCreateStoreState.fail:
        showAlert(setFailsAlert, teiHubLinkCreateStoreState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [teiHubLinkCreateStoreState]);

  useEffect(() => {
    switch (teiHubLinkDispatchMultiple.status) {
      case TeiHubLinkDispatchMultiple.inProgress:
        setOpenBackdropLoading(true);
        break;
      case TeiHubLinkDispatchMultiple.initial:
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkDispatchMultiple.success:
        showAlert(setSuccessAlert, teiHubLinkDispatchMultiple.message);
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkDispatchMultiple.fail:
        showAlert(setFailsAlert, teiHubLinkDispatchMultiple.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [teiHubLinkDispatchMultiple]);

  useEffect(() => {
    switch (teiHubLinkReturnRefundState.status) {
      case TeiHubLinkReturnRefund.inProgress:
        setOpenBackdropLoading(true);
        break;
      case TeiHubLinkReturnRefund.initial:
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkReturnRefund.success:
        showAlert(setSuccessAlert, teiHubLinkReturnRefundState.message);
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkReturnRefund.fail:
        showAlert(setFailsAlert, teiHubLinkReturnRefundState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [teiHubLinkReturnRefundState]);

  useEffect(() => {
    switch (teiHubLinkCompleteOrderState.status) {
      case TeiHubLinkCompleteOrder.inProgress:
        setOpenBackdropLoading(true);
        break;
      case TeiHubLinkCompleteOrder.initial:
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkCompleteOrder.success:
        showAlert(setSuccessAlert, teiHubLinkCompleteOrderState.message);
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkCompleteOrder.fail:
        showAlert(setFailsAlert, teiHubLinkCompleteOrderState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [teiHubLinkCompleteOrderState]);

  useEffect(() => {
    switch (teiHubLinkReceiveOrderState.status) {
      case TeiHubLinkReceiveOrder.inProgress:
        setOpenBackdropLoading(true);
        break;
      case TeiHubLinkReceiveOrder.initial:
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkReceiveOrder.success:
        showAlert(setSuccessAlert, teiHubLinkReceiveOrderState.message);
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkReceiveOrder.fail:
        showAlert(setFailsAlert, teiHubLinkReceiveOrderState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [teiHubLinkReceiveOrderState]);

  useEffect(() => {
    switch (teiHubLinkLogisticReceiveOrderState.status) {
      case TeiHubLinkLogisticReceiveOrder.inProgress:
        setOpenBackdropLoading(true);
        break;
      case TeiHubLinkLogisticReceiveOrder.initial:
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkLogisticReceiveOrder.success:
        showAlert(setSuccessAlert, teiHubLinkLogisticReceiveOrderState.message);
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkLogisticReceiveOrder.fail:
        showAlert(setFailsAlert, teiHubLinkLogisticReceiveOrderState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [teiHubLinkLogisticReceiveOrderState]);

  useEffect(() => {
    switch (teiHubLinkDispatchOrderState.status) {
      case TeiHubLinkDispatchOrder.inProgress:
        setOpenBackdropLoading(true);
        break;
      case TeiHubLinkDispatchOrder.initial:
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkDispatchOrder.success:
        showAlert(setSuccessAlert, teiHubLinkDispatchOrderState.message);
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkDispatchOrder.fail:
        showAlert(setFailsAlert, teiHubLinkDispatchOrderState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [teiHubLinkDispatchOrderState]);

  useEffect(() => {
    switch (teiHubLinkAcceptOrderState.status) {
      case TeiHubLinkAcceptOrder.inProgress:
        setOpenBackdropLoading(true);
        break;
      case TeiHubLinkAcceptOrder.initial:
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkAcceptOrder.success:
        showAlert(setSuccessAlert, teiHubLinkAcceptOrderState.message);
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkAcceptOrder.fail:
        showAlert(setFailsAlert, teiHubLinkAcceptOrderState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [teiHubLinkAcceptOrderState]);

  useEffect(() => {
    switch (teiHubLinkModifyOrderState.status) {
      case TeiHubLinkModifyOrder.inProgress:
        setOpenBackdropLoading(true);
        break;
      case TeiHubLinkModifyOrder.initial:
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkModifyOrder.success:
        showAlert(setSuccessAlert, teiHubLinkModifyOrderState.message);
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkModifyOrder.fail:
        showAlert(setFailsAlert, teiHubLinkModifyOrderState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [teiHubLinkModifyOrderState]);

  useEffect(() => {
    switch (teiHubLinkStoreCancelOrderState.status) {
      case TeiHubLinkStoreCancelOrder.inProgress:
        setOpenBackdropLoading(true);
        break;
      case TeiHubLinkStoreCancelOrder.initial:
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkStoreCancelOrder.success:
        showAlert(setSuccessAlert, teiHubLinkStoreCancelOrderState.message);
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkStoreCancelOrder.fail:
        showAlert(setFailsAlert, teiHubLinkStoreCancelOrderState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [teiHubLinkStoreCancelOrderState]);

  useEffect(() => {
    switch (teiHubLinkPlaceOrder.status) {
      case TeiHubLinkPlaceOrder.inProgress:
        setOpenBackdropLoading(true);
        break;
      case TeiHubLinkPlaceOrder.initial:
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkPlaceOrder.success:
        showAlert(setSuccessAlert, teiHubLinkPlaceOrder.message);
        setOpenBackdropLoading(false);
        break;
      case TeiHubLinkPlaceOrder.fail:
        showAlert(setFailsAlert, teiHubLinkPlaceOrder.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [teiHubLinkPlaceOrder]);

  useEffect(() => {
    switch (saveAssessmentState.status) {
      case SaveAssessmentState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case SaveAssessmentState.initial:
        setOpenBackdropLoading(false);
        break;
      case SaveAssessmentState.success:
        showAlert(setSuccessAlert, saveAssessmentState.message);
        setOpenBackdropLoading(false);
        break;
      case SaveAssessmentState.fail:
        showAlert(setFailsAlert, saveAssessmentState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [saveAssessmentState]);

  useEffect(() => {
    switch (hrImportUsersState.status) {
      case HrImportUsersState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case HrImportUsersState.initial:
        setOpenBackdropLoading(false);
        break;
      case HrImportUsersState.success:
        showAlert(setSuccessAlert, hrImportUsersState.message);
        setOpenBackdropLoading(false);
        break;
      case HrImportUsersState.fail:
        SweetAlert.fire({
          title: "Oops!",
          text: hrImportUsersState.message,
          icon: "error",
          background: "#22201A",
          color: "white",
        });
        setOpenBackdropLoading(false);
        break;
    }
  }, [hrImportUsersState]);

  useEffect(() => {
    switch (adminCateringBookingApproveOverrideState.status) {
      case AdminCateringBookingApproveOverrideState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AdminCateringBookingApproveOverrideState.initial:
        setOpenBackdropLoading(false);
        break;
      case AdminCateringBookingApproveOverrideState.success:
        setOpenBackdropLoading(false);
        break;
      case AdminCateringBookingApproveOverrideState.fail:
        SweetAlert.fire({
          title: "Oops!",
          text: adminCateringBookingApproveOverrideState.message,
          icon: "error",
          background: "#22201A",
          color: "white",
        });
        setOpenBackdropLoading(false);
        break;
    }
  }, [adminCateringBookingApproveOverrideState, dispatch]);

  useEffect(() => {
    switch (stockOrderSettingsProductChange.status) {
      case stockOrderSettingsProductInfoChangesState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case stockOrderSettingsProductInfoChangesState.initial:
        setOpenBackdropLoading(false);
        break;
      case stockOrderSettingsProductInfoChangesState.success:
        showAlert(setSuccessAlert, stockOrderSettingsProductChange.message);
        break;
      case stockOrderSettingsProductInfoChangesState.fail:
        showAlert(setFailsAlert, stockOrderSettingsProductChange.message);
        break;
    }
  }, [stockOrderSettingsProductChange]);

  // useEffect(() => {
  //   switch (stockOrderActiveStatusStates.status) {
  //     case stockOrderActiveStatusState.inProgress:
  //       setOpenBackdropLoading(true);
  //       break;
  //     case stockOrderActiveStatusState.initial:
  //       setOpenBackdropLoading(false);
  //       break;
  //     case stockOrderActiveStatusState.success:
  //       showAlert(setSuccessAlert, stockOrderActiveStatusStates.message);
  //       break;
  //     case stockOrderActiveStatusState.fail:
  //       showAlert(setFailsAlert, stockOrderActiveStatusStates.message);
  //       break;
  //   }
  // }, [stockOrderActiveStatusStates]);

  useEffect(() => {
    switch (stockOrderCreateProductStates.status) {
      case stockOrderCreateProductState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case stockOrderCreateProductState.initial:
        setOpenBackdropLoading(false);
        break;
      case stockOrderCreateProductState.success:
        showAlert(setSuccessAlert, stockOrderCreateProductStates.message);
        break;
      case stockOrderCreateProductState.fail:
        showAlert(setFailsAlert, stockOrderCreateProductStates.message);
        break;
    }
  }, [stockOrderCreateProductStates]);

  useEffect(() => {
    switch (stockOrderEditProductStates.status) {
      case stockOrderEditProductState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case stockOrderEditProductState.initial:
        setOpenBackdropLoading(false);
        break;
      case stockOrderEditProductState.success:
        showAlert(setSuccessAlert, stockOrderEditProductStates.message);
        break;
      case stockOrderEditProductState.fail:
        showAlert(setFailsAlert, stockOrderEditProductStates.message);
        break;
    }
  }, [stockOrderEditProductStates]);

  useEffect(() => {
    switch (getStockOrderAllStoresState.status) {
      case GetStockOrderAllStoresState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetStockOrderAllStoresState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetStockOrderAllStoresState.success:
        setOpenBackdropLoading(false);
        break;
      case GetStockOrderAllStoresState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getStockOrderAllStoresState]);

  useEffect(() => {
    switch (getStockOrderSettingProductsEditState.status) {
      case GetStockOrderSettingProductsEditState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetStockOrderSettingProductsEditState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetStockOrderSettingProductsEditState.success:
        setOpenBackdropLoading(false);
        break;
      case GetStockOrderSettingProductsEditState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getStockOrderSettingProductsEditState.status]);

  useEffect(() => {
    switch (getStockOrderSettingProducts.status) {
      case GetStockOrderSettingProductsState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetStockOrderSettingProductsState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetStockOrderSettingProductsState.success:
        setOpenBackdropLoading(false);
        break;
      case GetStockOrderSettingProductsState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getStockOrderSettingProducts]);

  useEffect(() => {
    switch (submitAssessmentState.status) {
      case SubmitAssessmentState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case SubmitAssessmentState.initial:
        setOpenBackdropLoading(false);
        break;
      case SubmitAssessmentState.success:
        showAlert(setSuccessAlert, submitAssessmentState.message);
        setOpenBackdropLoading(false);
        break;
      case SubmitAssessmentState.fail:
        showAlert(setFailsAlert, submitAssessmentState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [submitAssessmentState]);

  useEffect(() => {
    switch (updateActionItemState.status) {
      case UpdateActionItemState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateActionItemState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateActionItemState.success:
        showAlert(setSuccessAlert, updateActionItemState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateActionItemState.fail:
        showAlert(setFailsAlert, updateActionItemState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateActionItemState]);

  useEffect(() => {
    switch (updateKraState.status) {
      case UpdateKraState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateKraState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateKraState.success:
        showAlert(setSuccessAlert, updateKraState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateKraState.fail:
        showAlert(setFailsAlert, updateKraState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateKraState]);

  useEffect(() => {
    switch (submitKraState.status) {
      case SubmitKraState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case SubmitKraState.initial:
        setOpenBackdropLoading(false);
        break;
      case SubmitKraState.success:
        showAlert(setSuccessAlert, submitKraState.message);
        setOpenBackdropLoading(false);
        break;
      case SubmitKraState.fail:
        showAlert(setFailsAlert, submitKraState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [submitKraState]);

  useEffect(() => {
    switch (stockUpdateOrderItems.status) {
      case updateOrderItemsState.initial:
        setOpenBackdropLoading(true);
        break;
      case updateOrderItemsState.inProgress:
        setOpenBackdropLoading(false);
        break;
      case updateOrderItemsState.success:
        showAlert(setSuccessAlert, stockUpdateOrderItems.message);
        setOpenBackdropLoading(false);
        break;
      case updateOrderItemsState.fail:
        showAlert(setFailsAlert, stockUpdateOrderItems.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [stockUpdateOrderItems]);

  useEffect(() => {
    switch (stockCancelOrder.status) {
      case updateOrderCancelledState.initial:
        setOpenBackdropLoading(true);
        break;
      case updateOrderCancelledState.inProgress:
        setOpenBackdropLoading(false);
        break;
      case updateOrderCancelledState.success:
        showAlert(setSuccessAlert, stockCancelOrder.message);
        setOpenBackdropLoading(false);
        break;
      case updateOrderCancelledState.fail:
        showAlert(setFailsAlert, stockCancelOrder.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [stockCancelOrder]);

  useEffect(() => {
    switch (stockUpdateConfirmPaymentState.status) {
      case updateConfirmPaymentState.initial:
        setOpenBackdropLoading(true);
        break;
      case updateConfirmPaymentState.inProgress:
        setOpenBackdropLoading(false);
        break;
      case updateConfirmPaymentState.success:
        showAlert(setSuccessAlert, stockUpdateConfirmPaymentState.message);
        setOpenBackdropLoading(false);
        break;
      case updateConfirmPaymentState.fail:
        showAlert(setFailsAlert, stockUpdateConfirmPaymentState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [stockUpdateConfirmPaymentState]);

  useEffect(() => {
    switch (stockUpdatePayBillingOrderState.status) {
      case updatePayBillingOrdersState.initial:
        setOpenBackdropLoading(true);
        break;
      case updatePayBillingOrdersState.inProgress:
        setOpenBackdropLoading(false);
        break;
      case updatePayBillingOrdersState.success:
        showAlert(setSuccessAlert, stockUpdatePayBillingOrderState.message);
        setOpenBackdropLoading(false);
        break;
      case updatePayBillingOrdersState.fail:
        showAlert(setFailsAlert, stockUpdatePayBillingOrderState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [stockUpdatePayBillingOrderState]);

  useEffect(() => {
    switch (stockUpdateBillingOrderState.status) {
      case updateBillingOrdersState.initial:
        setOpenBackdropLoading(true);
        break;
      case updateBillingOrdersState.inProgress:
        setOpenBackdropLoading(false);
        break;
      case updateBillingOrdersState.success:
        showAlert(setSuccessAlert, stockUpdateBillingOrderState.message);
        setOpenBackdropLoading(false);
        break;
      case updateBillingOrdersState.fail:
        showAlert(setFailsAlert, stockUpdateBillingOrderState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [stockUpdateBillingOrderState]);

  useEffect(() => {
    switch (stockDeliveryApprovalState.status) {
      case StockDeliveryApprovalState.initial:
        setOpenBackdropLoading(true);
        break;
      case StockDeliveryApprovalState.inProgress:
        setOpenBackdropLoading(false);
        break;
      case StockDeliveryApprovalState.success:
        showAlert(setSuccessAlert, stockDeliveryApprovalState.message);
        setOpenBackdropLoading(false);
        break;
      case StockDeliveryApprovalState.fail:
        showAlert(setFailsAlert, stockDeliveryApprovalState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [stockDeliveryApprovalState]);

  useEffect(() => {
    switch (stockUpdateReceiveOrderState.status) {
      case updateReceiveOrdersState.initial:
        setOpenBackdropLoading(true);
        break;
      case updateReceiveOrdersState.inProgress:
        setOpenBackdropLoading(false);
        break;
      case updateReceiveOrdersState.success:
        showAlert(setSuccessAlert, stockUpdateReceiveOrderState.message);
        setOpenBackdropLoading(false);
        break;
      case updateReceiveOrdersState.fail:
        showAlert(setFailsAlert, stockUpdateReceiveOrderState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [stockUpdateReceiveOrderState]);

  useEffect(() => {
    switch (stockDispatchOrderState.status) {
      case StockDispatchOrdersState.initial:
        setOpenBackdropLoading(true);
        break;
      case StockDispatchOrdersState.inProgress:
        setOpenBackdropLoading(false);
        break;
      case StockDispatchOrdersState.success:
        showAlert(setSuccessAlert, stockDispatchOrderState.message);
        setOpenBackdropLoading(false);
        break;
      case StockDispatchOrdersState.fail:
        showAlert(setFailsAlert, stockDispatchOrderState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [stockDispatchOrderState]);

  useEffect(() => {
    switch (stockUpdateReviewOrderState.status) {
      case updateReviewOrdersState.initial:
        setOpenBackdropLoading(true);
        break;
      case updateReviewOrdersState.inProgress:
        setOpenBackdropLoading(false);
        break;
      case updateReviewOrdersState.success:
        showAlert(setSuccessAlert, stockUpdateReviewOrderState.message);
        setOpenBackdropLoading(false);
        break;
      case updateReviewOrdersState.fail:
        showAlert(setFailsAlert, stockUpdateReviewOrderState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [stockUpdateReviewOrderState]);

  useEffect(() => {
    switch (updateStockOrderNewOrder.status) {
      case updateNewOrdersState.initial:
        setOpenBackdropLoading(true);
        break;
      case updateNewOrdersState.inProgress:
        setOpenBackdropLoading(false);
        break;
      case updateNewOrdersState.success:
        showAlert(setSuccessAlert, updateStockOrderNewOrder.message);
        setOpenBackdropLoading(false);
        break;
      case updateNewOrdersState.fail:
        showAlert(setFailsAlert, updateStockOrderNewOrder.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateStockOrderNewOrder]);

  useEffect(() => {
    switch (insertStockOrderingNewOrder.status) {
      case InsertNewOrderState.initial:
        setOpenBackdropLoading(true);
        break;
      case InsertNewOrderState.inProgress:
        setOpenBackdropLoading(false);
        break;
      case InsertNewOrderState.success:
        showAlert(setSuccessAlert, insertStockOrderingNewOrder.message);
        setOpenBackdropLoading(false);
        break;
      case InsertNewOrderState.fail:
        showAlert(setFailsAlert, insertStockOrderingNewOrder.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [insertStockOrderingNewOrder]);

  useEffect(() => {
    switch (adminInfluencerCashoutChangeStatusState.status) {
      case AdminInfluencerCashoutChangeStatusState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AdminInfluencerCashoutChangeStatusState.initial:
        setOpenBackdropLoading(false);
        break;
      case AdminInfluencerCashoutChangeStatusState.success:
        showAlert(
          setSuccessAlert,
          adminInfluencerCashoutChangeStatusState.message
        );
        setOpenBackdropLoading(false);
        break;
      case AdminInfluencerCashoutChangeStatusState.fail:
        showAlert(
          setFailsAlert,
          adminInfluencerCashoutChangeStatusState.message
        );
        setOpenBackdropLoading(false);
        break;
    }
  }, [adminInfluencerCashoutChangeStatusState]);

  useEffect(() => {
    switch (validatePartnerCompanyEmployeeIdNumberAdminState.status) {
      case ValidatePartnerCompanyEmployeeIdNumberAdminState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case ValidatePartnerCompanyEmployeeIdNumberAdminState.initial:
        setOpenBackdropLoading(false);
        break;
      case ValidatePartnerCompanyEmployeeIdNumberAdminState.success:
        showAlert(
          setSuccessAlert,
          validatePartnerCompanyEmployeeIdNumberAdminState.message
        );
        setOpenBackdropLoading(false);
        break;
      case ValidatePartnerCompanyEmployeeIdNumberAdminState.fail:
        showAlert(
          setFailsAlert,
          validatePartnerCompanyEmployeeIdNumberAdminState.message
        );
        setOpenBackdropLoading(false);
        break;
    }
  }, [validatePartnerCompanyEmployeeIdNumberAdminState]);

  useEffect(() => {
    switch (influencerCashoutState.status) {
      case InfluencerCashoutState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case InfluencerCashoutState.initial:
        setOpenBackdropLoading(false);
        break;
      case InfluencerCashoutState.success:
        showAlert(setSuccessAlert, influencerCashoutState.message);
        setOpenBackdropLoading(false);
        break;
      case InfluencerCashoutState.fail:
        showAlert(setFailsAlert, influencerCashoutState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [influencerCashoutState]);

  useEffect(() => {
    switch (createAdminInfluencerPromoState.status) {
      case CreateAdminInfluencerPromoState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CreateAdminInfluencerPromoState.initial:
        setOpenBackdropLoading(false);
        break;
      case CreateAdminInfluencerPromoState.success:
        showAlert(setSuccessAlert, createAdminInfluencerPromoState.message);
        setOpenBackdropLoading(false);
        break;
      case CreateAdminInfluencerPromoState.fail:
        showAlert(setFailsAlert, createAdminInfluencerPromoState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [createAdminInfluencerPromoState]);

  useEffect(() => {
    switch (uploadContractInfluencerState.status) {
      case UploadContractInfluencerState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UploadContractInfluencerState.initial:
        setOpenBackdropLoading(false);
        break;
      case UploadContractInfluencerState.success:
        showAlert(setSuccessAlert, uploadContractInfluencerState.message);
        setOpenBackdropLoading(false);
        break;
      case UploadContractInfluencerState.fail:
        showAlert(setFailsAlert, uploadContractInfluencerState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [uploadContractInfluencerState]);

  useEffect(() => {
    switch (getSnackshopInfluencerPromoState.status) {
      case GetSnackshopInfluencerPromoState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetSnackshopInfluencerPromoState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetSnackshopInfluencerPromoState.success:
        showAlert(setSuccessAlert, getSnackshopInfluencerPromoState.message);
        setOpenBackdropLoading(false);
        break;
      case GetSnackshopInfluencerPromoState.fail:
        showAlert(setFailsAlert, getSnackshopInfluencerPromoState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [getSnackshopInfluencerPromoState]);

  useEffect(() => {
    switch (adminInfluencerApplicationChangeStatusState.status) {
      case AdminInfluencerApplicationChangeStatusState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AdminInfluencerApplicationChangeStatusState.initial:
        setOpenBackdropLoading(false);
        break;
      case AdminInfluencerApplicationChangeStatusState.success:
        showAlert(
          setSuccessAlert,
          adminInfluencerApplicationChangeStatusState.message
        );
        setOpenBackdropLoading(false);
        break;
      case AdminInfluencerApplicationChangeStatusState.fail:
        showAlert(
          setFailsAlert,
          adminInfluencerApplicationChangeStatusState.message
        );
        setOpenBackdropLoading(false);
        break;
    }
  }, [adminInfluencerApplicationChangeStatusState]);

  useEffect(() => {
    switch (updateInfluencerState.status) {
      case UpdateInfluencerState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateInfluencerState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateInfluencerState.success:
        showAlert(setSuccessAlert, updateInfluencerState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateInfluencerState.fail:
        showAlert(setFailsAlert, updateInfluencerState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateInfluencerState]);

  useEffect(() => {
    switch (applyInfluencerState.status) {
      case ApplyInfluencerState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case ApplyInfluencerState.initial:
        setOpenBackdropLoading(false);
        break;
      case ApplyInfluencerState.success:
        showAlert(setSuccessAlert, applyInfluencerState.message);
        setOpenBackdropLoading(false);
        break;
      case ApplyInfluencerState.fail:
        showAlert(setFailsAlert, applyInfluencerState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [applyInfluencerState]);

  useEffect(() => {
    switch (editAdminSettingPopclubDealState.status) {
      case EditAdminSettingPopclubDealState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case EditAdminSettingPopclubDealState.initial:
        setOpenBackdropLoading(false);
        break;
      case EditAdminSettingPopclubDealState.success:
        showAlert(setSuccessAlert, editAdminSettingPopclubDealState.message);
        setOpenBackdropLoading(false);
        break;
      case EditAdminSettingPopclubDealState.fail:
        showAlert(setFailsAlert, editAdminSettingPopclubDealState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [editAdminSettingPopclubDealState]);

  useEffect(() => {
    switch (createAdminSettingPopclubDealState.status) {
      case CreateAdminSettingPopclubDealState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CreateAdminSettingPopclubDealState.initial:
        setOpenBackdropLoading(false);
        break;
      case CreateAdminSettingPopclubDealState.success:
        showAlert(setSuccessAlert, createAdminSettingPopclubDealState.message);
        setOpenBackdropLoading(false);
        break;
      case CreateAdminSettingPopclubDealState.fail:
        showAlert(setFailsAlert, createAdminSettingPopclubDealState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [createAdminSettingPopclubDealState]);

  useEffect(() => {
    switch (copyAdminSettingCateringPackageState.status) {
      case CopyAdminSettingCateringPackageState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CopyAdminSettingCateringPackageState.initial:
        setOpenBackdropLoading(false);
        break;
      case CopyAdminSettingCateringPackageState.success:
        showAlert(
          setSuccessAlert,
          copyAdminSettingCateringPackageState.message
        );
        setOpenBackdropLoading(false);
        break;
      case CopyAdminSettingCateringPackageState.fail:
        showAlert(setFailsAlert, copyAdminSettingCateringPackageState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [copyAdminSettingCateringPackageState]);

  useEffect(() => {
    switch (editAdminSettingCateringPackageState.status) {
      case EditAdminSettingCateringPackageState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case EditAdminSettingCateringPackageState.initial:
        setOpenBackdropLoading(false);
        break;
      case EditAdminSettingCateringPackageState.success:
        showAlert(
          setSuccessAlert,
          editAdminSettingCateringPackageState.message
        );
        setOpenBackdropLoading(false);
        break;
      case EditAdminSettingCateringPackageState.fail:
        showAlert(setFailsAlert, editAdminSettingCateringPackageState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [editAdminSettingCateringPackageState]);

  useEffect(() => {
    switch (createAdminSettingCateringPackageState.status) {
      case CreateAdminSettingCateringPackageState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CreateAdminSettingCateringPackageState.initial:
        setOpenBackdropLoading(false);
        break;
      case CreateAdminSettingCateringPackageState.success:
        showAlert(
          setSuccessAlert,
          createAdminSettingCateringPackageState.message
        );
        setOpenBackdropLoading(false);
        break;
      case CreateAdminSettingCateringPackageState.fail:
        showAlert(
          setFailsAlert,
          createAdminSettingCateringPackageState.message
        );
        setOpenBackdropLoading(false);
        break;
    }
  }, [createAdminSettingCateringPackageState]);

  useEffect(() => {
    switch (copyAdminSettingShopProductState.status) {
      case CopyAdminSettingShopProductState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CopyAdminSettingShopProductState.initial:
        setOpenBackdropLoading(false);
        break;
      case CopyAdminSettingShopProductState.success:
        showAlert(setSuccessAlert, copyAdminSettingShopProductState.message);
        setOpenBackdropLoading(false);
        break;
      case CopyAdminSettingShopProductState.fail:
        showAlert(setFailsAlert, copyAdminSettingShopProductState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [copyAdminSettingShopProductState]);

  useEffect(() => {
    switch (editAdminSettingStoreState.status) {
      case EditAdminSettingStoreState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case EditAdminSettingStoreState.initial:
        setOpenBackdropLoading(false);
        break;
      case EditAdminSettingStoreState.success:
        showAlert(setSuccessAlert, editAdminSettingStoreState.message);
        setOpenBackdropLoading(false);
        break;
      case EditAdminSettingStoreState.fail:
        showAlert(setFailsAlert, editAdminSettingStoreState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [editAdminSettingStoreState]);

  useEffect(() => {
    switch (getAdminSettingStoreState.status) {
      case GetAdminSettingStoreState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetAdminSettingStoreState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetAdminSettingStoreState.success:
        setOpenBackdropLoading(false);
        break;
      case GetAdminSettingStoreState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getAdminSettingStoreState]);

  useEffect(() => {
    switch (createAdminSettingStoreState.status) {
      case CreateAdminSettingStoreState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CreateAdminSettingStoreState.initial:
        setOpenBackdropLoading(false);
        break;
      case CreateAdminSettingStoreState.success:
        showAlert(setSuccessAlert, createAdminSettingStoreState.message);
        setOpenBackdropLoading(false);
        break;
      case CreateAdminSettingStoreState.fail:
        showAlert(setFailsAlert, createAdminSettingStoreState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [createAdminSettingStoreState]);

  useEffect(() => {
    switch (adminCateringBookingOverrideEventDateState.status) {
      case AdminCateringBookingOverrideEventDateState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AdminCateringBookingOverrideEventDateState.initial:
        setOpenBackdropLoading(false);
        break;
      case AdminCateringBookingOverrideEventDateState.success:
        setOpenBackdropLoading(false);
        break;
      case AdminCateringBookingOverrideEventDateState.fail:
        SweetAlert.fire({
          title: "Oops...",
          text: adminCateringBookingOverrideEventDateState.message,
          icon: "error",
          background: "#22201A",
          color: "white",
        });
        setOpenBackdropLoading(false);
        break;
    }
  }, [adminCateringBookingOverrideEventDateState, dispatch]);

  useEffect(() => {
    switch (setCateringStoreAndAddressState.status) {
      case SetCateringStoreAndAddressState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case SetCateringStoreAndAddressState.initial:
        setOpenBackdropLoading(false);
        break;
      case SetCateringStoreAndAddressState.success:
        setOpenBackdropLoading(false);
        break;
      case SetCateringStoreAndAddressState.fail:
        SweetAlert.fire({
          title: "Oops!",
          text: setCateringStoreAndAddressState.message,
          icon: "error",
          background: "#22201A",
          color: "white",
        });
        setOpenBackdropLoading(false);
        break;
    }
  }, [setCateringStoreAndAddressState, dispatch]);

  useEffect(() => {
    switch (setSnackshopStoreAndAddressState.status) {
      case SetSnackshopStoreAndAddressState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case SetSnackshopStoreAndAddressState.initial:
        setOpenBackdropLoading(false);
        break;
      case SetSnackshopStoreAndAddressState.success:
        setOpenBackdropLoading(false);
        break;
      case SetSnackshopStoreAndAddressState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [setSnackshopStoreAndAddressState, dispatch]);

  useEffect(() => {
    switch (setSnacksDeliveredDealStoreAndAddressState.status) {
      case SetSnacksDeliveredDealStoreAndAddressState.inProgress:
        setOpenBackdropPopClubLoading(true);
        break;
      case SetSnacksDeliveredDealStoreAndAddressState.initial:
        setOpenBackdropPopClubLoading(false);
        break;
      case SetSnacksDeliveredDealStoreAndAddressState.success:
        setOpenBackdropPopClubLoading(false);
        break;
      case SetSnacksDeliveredDealStoreAndAddressState.fail:
        setOpenBackdropPopClubLoading(false);
        break;
    }
  }, [setSnacksDeliveredDealStoreAndAddressState, dispatch]);

  useEffect(() => {
    switch (getSnacksDeliveredDealAvailableStoresState.status) {
      case GetSnacksDeliveredDealAvailableStoresState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetSnacksDeliveredDealAvailableStoresState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetSnacksDeliveredDealAvailableStoresState.success:
        setOpenBackdropLoading(false);
        break;
      case GetSnacksDeliveredDealAvailableStoresState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getSnacksDeliveredDealAvailableStoresState]);

  useEffect(() => {
    switch (addToCartCateringProductState.status) {
      case AddToCartCateringProductState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AddToCartCateringProductState.initial:
        setOpenBackdropLoading(false);
        break;
      case AddToCartCateringProductState.success:
        SweetAlert.fire({
          title: "Package Created!",
          text: addToCartCateringProductState.message,
          icon: "success",
          background: "#22201A",
          color: "white",
        });
        setOpenBackdropLoading(false);
        break;
      case AddToCartCateringProductState.fail:
        SweetAlert.fire({
          title: "Oops...",
          text: addToCartCateringProductState.message,
          icon: "error",
          background: "#22201A",
          color: "white",
        });
        setOpenBackdropLoading(false);
        break;
    }
  }, [addToCartCateringProductState]);

  useEffect(() => {
    switch (updateAdminCateringOrderItemRemarksState.status) {
      case UpdateAdminCateringOrderItemRemarksState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateAdminCateringOrderItemRemarksState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateAdminCateringOrderItemRemarksState.success:
        showAlert(
          setSuccessAlert,
          updateAdminCateringOrderItemRemarksState.message
        );
        setOpenBackdropLoading(false);
        break;
      case UpdateAdminCateringOrderItemRemarksState.fail:
        showAlert(
          setFailsAlert,
          updateAdminCateringOrderItemRemarksState.message
        );
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateAdminCateringOrderItemRemarksState]);

  const insertCustomerSurveyResponseState = useAppSelector(
    selectInsertCustomerSurveyResponse
  );

  const createAdminSettingShopProductState = useAppSelector(
    selectCreateAdminSettingShopProduct
  );

  const editAdminSettingShopProductState = useAppSelector(
    selectEditAdminSettingShopProduct
  );

  const deleteAdminSettingShopProductState = useAppSelector(
    selectDeleteAdminSettingShopProduct
  );

  useEffect(() => {
    switch (deleteAdminSettingShopProductState.status) {
      case DeleteAdminSettingShopProductState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case DeleteAdminSettingShopProductState.initial:
        setOpenBackdropLoading(false);
        break;
      case DeleteAdminSettingShopProductState.success:
        showAlert(setSuccessAlert, deleteAdminSettingShopProductState.message);
        setOpenBackdropLoading(false);
        break;
      case DeleteAdminSettingShopProductState.fail:
        showAlert(setFailsAlert, deleteAdminSettingShopProductState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [deleteAdminSettingShopProductState]);

  useEffect(() => {
    switch (editAdminSettingShopProductState.status) {
      case EditAdminSettingShopProductState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case EditAdminSettingShopProductState.initial:
        setOpenBackdropLoading(false);
        break;
      case EditAdminSettingShopProductState.success:
        showAlert(setSuccessAlert, editAdminSettingShopProductState.message);
        setOpenBackdropLoading(false);
        break;
      case EditAdminSettingShopProductState.fail:
        showAlert(setFailsAlert, editAdminSettingShopProductState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [editAdminSettingShopProductState]);

  useEffect(() => {
    switch (createAdminSettingShopProductState.status) {
      case CreateAdminSettingShopProductState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CreateAdminSettingShopProductState.initial:
        setOpenBackdropLoading(false);
        break;
      case CreateAdminSettingShopProductState.success:
        showAlert(setSuccessAlert, createAdminSettingShopProductState.message);
        setOpenBackdropLoading(false);
        break;
      case CreateAdminSettingShopProductState.fail:
        showAlert(setFailsAlert, createAdminSettingShopProductState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [createAdminSettingShopProductState]);

  useEffect(() => {
    switch (insertCustomerSurveyResponseState.status) {
      case InsertCustomerSurveyResponseState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case InsertCustomerSurveyResponseState.initial:
        setOpenBackdropLoading(false);
        break;
      case InsertCustomerSurveyResponseState.success:
        showAlert(setSuccessAlert, insertCustomerSurveyResponseState.message);
        setOpenBackdropLoading(false);
        break;
      case InsertCustomerSurveyResponseState.fail:
        showAlert(setFailsAlert, insertCustomerSurveyResponseState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [insertCustomerSurveyResponseState]);

  useEffect(() => {
    switch (updateBscUserState.status) {
      case UpdateBscUserState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateBscUserState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateBscUserState.success:
        showAlert(setSuccessAlert, updateBscUserState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateBscUserState.fail:
        showAlert(setFailsAlert, updateBscUserState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateBscUserState]);

  useEffect(() => {
    switch (updateBscUserStatusState.status) {
      case UpdateBscUserStatusState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateBscUserStatusState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateBscUserStatusState.success:
        showAlert(setSuccessAlert, updateBscUserStatusState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateBscUserStatusState.fail:
        showAlert(setFailsAlert, updateBscUserStatusState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateBscUserStatusState]);

  useEffect(() => {
    switch (createBscUserState.status) {
      case CreateBscUserState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CreateBscUserState.initial:
        setOpenBackdropLoading(false);
        break;
      case CreateBscUserState.success:
        showAlert(setSuccessAlert, createBscUserState.message);
        setOpenBackdropLoading(false);
        break;
      case CreateBscUserState.fail:
        showAlert(setFailsAlert, createBscUserState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [createBscUserState]);

  useEffect(() => {
    switch (loginBscState.status) {
      case LoginBscState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case LoginBscState.initial:
        setOpenBackdropLoading(false);
        break;
      case LoginBscState.success:
        showAlert(setSuccessAlert, loginBscState.message);
        setOpenBackdropLoading(false);
        break;
      case LoginBscState.fail:
        showAlert(setFailsAlert, loginBscState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [loginBscState]);

  useEffect(() => {
    switch (updateUserDiscountState.status) {
      case UpdateUserDiscountState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateUserDiscountState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateUserDiscountState.success:
        showAlert(setSuccessAlert, updateUserDiscountState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateUserDiscountState.fail:
        showAlert(setFailsAlert, updateUserDiscountState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateUserDiscountState]);

  useEffect(() => {
    switch (adminUserDiscountChangeStatusState.status) {
      case AdminUserDiscountChangeStatusState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AdminUserDiscountChangeStatusState.initial:
        setOpenBackdropLoading(false);
        break;
      case AdminUserDiscountChangeStatusState.success:
        showAlert(setSuccessAlert, adminUserDiscountChangeStatusState.message);
        setOpenBackdropLoading(false);
        break;
      case AdminUserDiscountChangeStatusState.fail:
        showAlert(setFailsAlert, adminUserDiscountChangeStatusState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [adminUserDiscountChangeStatusState]);

  useEffect(() => {
    switch (applyUserDiscountState.status) {
      case ApplyUserDiscountState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case ApplyUserDiscountState.initial:
        setOpenBackdropLoading(false);
        break;
      case ApplyUserDiscountState.success:
        showAlert(setSuccessAlert, applyUserDiscountState.message);
        setOpenBackdropLoading(false);
        break;
      case ApplyUserDiscountState.fail:
        showAlert(setFailsAlert, applyUserDiscountState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [applyUserDiscountState]);

  useEffect(() => {
    switch (applyUserDiscountState.status) {
      case ApplyUserDiscountState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case ApplyUserDiscountState.initial:
        setOpenBackdropLoading(false);
        break;
      case ApplyUserDiscountState.success:
        showAlert(setSuccessAlert, applyUserDiscountState.message);
        setOpenBackdropLoading(false);
        break;
      case ApplyUserDiscountState.fail:
        showAlert(setFailsAlert, applyUserDiscountState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [applyUserDiscountState]);

  useEffect(() => {
    switch (getStoresAvailableCateringModalState.status) {
      case GetStoresAvailableCateringModalState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetStoresAvailableCateringModalState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetStoresAvailableCateringModalState.success:
        setOpenBackdropLoading(false);
        break;
      case GetStoresAvailableCateringModalState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getStoresAvailableCateringModalState]);

  useEffect(() => {
    switch (getStoresAvailableSnackshopModalState.status) {
      case GetStoresAvailableSnackshopModalState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetStoresAvailableSnackshopModalState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetStoresAvailableSnackshopModalState.success:
        setOpenBackdropLoading(false);
        break;
      case GetStoresAvailableSnackshopModalState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getStoresAvailableSnackshopModalState]);

  useEffect(() => {
    switch (adminCateringPrivilegeState.status) {
      case AdminCateringPrivilegeState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AdminCateringPrivilegeState.initial:
        setOpenBackdropLoading(false);
        break;
      case AdminCateringPrivilegeState.success:
        showAlert(setSuccessAlert, adminCateringPrivilegeState.message);
        setOpenBackdropLoading(false);
        break;
      case AdminCateringPrivilegeState.fail:
        showAlert(setFailsAlert, adminCateringPrivilegeState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [adminCateringPrivilegeState]);

  useEffect(() => {
    switch (updateStoreCatersProductAddonState.status) {
      case UpdateStoreCatersProductAddonState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateStoreCatersProductAddonState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateStoreCatersProductAddonState.success:
        showAlert(setSuccessAlert, updateStoreCatersProductAddonState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateStoreCatersProductAddonState.fail:
        showAlert(setFailsAlert, updateStoreCatersProductAddonState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateStoreCatersProductAddonState]);

  useEffect(() => {
    switch (updateStoreCatersPackageAddonState.status) {
      case UpdateStoreCatersPackageAddonState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateStoreCatersPackageAddonState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateStoreCatersPackageAddonState.success:
        showAlert(setSuccessAlert, updateStoreCatersPackageAddonState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateStoreCatersPackageAddonState.fail:
        showAlert(setFailsAlert, updateStoreCatersPackageAddonState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateStoreCatersPackageAddonState]);

  useEffect(() => {
    switch (updateStoreCatersPackageState.status) {
      case UpdateStoreCatersPackageState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateStoreCatersPackageState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateStoreCatersPackageState.success:
        showAlert(setSuccessAlert, updateStoreCatersPackageState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateStoreCatersPackageState.fail:
        showAlert(setFailsAlert, updateStoreCatersPackageState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateStoreCatersPackageState]);

  useEffect(() => {
    switch (updateStoreProductState.status) {
      case UpdateStoreProductState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateStoreProductState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateStoreProductState.success:
        showAlert(setSuccessAlert, updateStoreProductState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateStoreProductState.fail:
        showAlert(setFailsAlert, updateStoreProductState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateStoreProductState]);

  useEffect(() => {
    switch (getAdminSettingStoresState.status) {
      case GetAdminSettingStoresState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetAdminSettingStoresState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetAdminSettingStoresState.success:
        setOpenBackdropLoading(false);
        break;
      case GetAdminSettingStoresState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getAdminSettingStoresState]);

  useEffect(() => {
    switch (adminDeclineRedeemState.status) {
      case AdminDeclineRedeemState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AdminDeclineRedeemState.initial:
        setOpenBackdropLoading(false);
        break;
      case AdminDeclineRedeemState.success:
        showAlert(setSuccessAlert, adminDeclineRedeemState.message);
        setOpenBackdropLoading(false);
        break;
      case AdminDeclineRedeemState.fail:
        showAlert(setFailsAlert, adminDeclineRedeemState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [adminDeclineRedeemState]);

  useEffect(() => {
    switch (updateStoreDealState.status) {
      case UpdateStoreDealState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateStoreDealState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateStoreDealState.success:
        showAlert(setSuccessAlert, updateStoreDealState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateStoreDealState.fail:
        showAlert(setFailsAlert, updateStoreDealState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateStoreDealState]);

  useEffect(() => {
    switch (adminCateringBookingUpdateStatusState.status) {
      case AdminCateringBookingUpdateStatusState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AdminCateringBookingUpdateStatusState.initial:
        setOpenBackdropLoading(false);
        break;
      case AdminCateringBookingUpdateStatusState.success:
        showAlert(
          setSuccessAlert,
          adminCateringBookingUpdateStatusState.message
        );
        setOpenBackdropLoading(false);
        break;
      case AdminCateringBookingUpdateStatusState.fail:
        showAlert(setFailsAlert, adminCateringBookingUpdateStatusState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [adminCateringBookingUpdateStatusState]);

  useEffect(() => {
    switch (adminPrivilegeState.status) {
      case AdminPrivilegeState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AdminPrivilegeState.initial:
        setOpenBackdropLoading(false);
        break;
      case AdminPrivilegeState.success:
        showAlert(setSuccessAlert, adminPrivilegeState.message);
        setOpenBackdropLoading(false);
        break;
      case AdminPrivilegeState.fail:
        showAlert(setFailsAlert, adminPrivilegeState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [adminPrivilegeState]);

  useEffect(() => {
    switch (adminShopOrderUpdateStatusState.status) {
      case AdminShopOrderUpdateStatusState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AdminShopOrderUpdateStatusState.initial:
        setOpenBackdropLoading(false);
        break;
      case AdminShopOrderUpdateStatusState.success:
        showAlert(setSuccessAlert, adminShopOrderUpdateStatusState.message);
        setOpenBackdropLoading(false);
        break;
      case AdminShopOrderUpdateStatusState.fail:
        showAlert(setFailsAlert, adminShopOrderUpdateStatusState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [adminShopOrderUpdateStatusState]);

  useEffect(() => {
    switch (validateReferenceNumberAdminState.status) {
      case ValidateReferenceNumberAdminState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case ValidateReferenceNumberAdminState.initial:
        setOpenBackdropLoading(false);
        break;
      case ValidateReferenceNumberAdminState.success:
        showAlert(setSuccessAlert, validateReferenceNumberAdminState.message);
        setOpenBackdropLoading(false);
        break;
      case ValidateReferenceNumberAdminState.fail:
        showAlert(setFailsAlert, validateReferenceNumberAdminState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [validateReferenceNumberAdminState]);

  useEffect(() => {
    switch (uploadProofOfPaymentAdminState.status) {
      case UploadProofOfPaymentAdminState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UploadProofOfPaymentAdminState.initial:
        setOpenBackdropLoading(false);
        break;
      case UploadProofOfPaymentAdminState.success:
        showAlert(setSuccessAlert, uploadProofOfPaymentAdminState.message);
        setOpenBackdropLoading(false);
        break;
      case UploadProofOfPaymentAdminState.fail:
        showAlert(setFailsAlert, uploadProofOfPaymentAdminState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [uploadProofOfPaymentAdminState]);

  useEffect(() => {
    switch (createAdminGroupState.status) {
      case CreateAdminGroupState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CreateAdminGroupState.initial:
        setOpenBackdropLoading(false);
        break;
      case CreateAdminGroupState.success:
        showAlert(setSuccessAlert, createAdminGroupState.message);
        setOpenBackdropLoading(false);
        break;
      case CreateAdminGroupState.fail:
        showAlert(setFailsAlert, createAdminGroupState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [createAdminGroupState]);

  useEffect(() => {
    switch (updateAdminSettingUserStores.status) {
      case UpdateAdminSettingUserStoresState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateAdminSettingUserStoresState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateAdminSettingUserStoresState.success:
        showAlert(setSuccessAlert, updateAdminSettingUserStores.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateAdminSettingUserStoresState.fail:
        showAlert(setFailsAlert, updateAdminSettingUserStores.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateAdminSettingUserStores]);

  useEffect(() => {
    switch (getAdminSettingUserStoresState.status) {
      case GetAdminSettingUserStoresState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetAdminSettingUserStoresState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetAdminSettingUserStoresState.success:
        setOpenBackdropLoading(false);
        break;
      case GetAdminSettingUserStoresState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getAdminSettingUserStoresState]);

  useEffect(() => {
    switch (getAdminSettingUserStoreState.status) {
      case GetAdminSettingUserStoreState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetAdminSettingUserStoreState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetAdminSettingUserStoreState.success:
        setOpenBackdropLoading(false);
        break;
      case GetAdminSettingUserStoreState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getAdminSettingUserStoreState]);

  useEffect(() => {
    switch (editAdminUserState.status) {
      case EditAdminUserState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case EditAdminUserState.initial:
        setOpenBackdropLoading(false);
        break;
      case EditAdminUserState.success:
        showAlert(setSuccessAlert, editAdminUserState.message);
        setOpenBackdropLoading(false);
        break;
      case EditAdminUserState.fail:
        showAlert(setFailsAlert, editAdminUserState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [editAdminUserState]);

  useEffect(() => {
    switch (getAdminGroupsState.status) {
      case GetAdminGroupsState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetAdminGroupsState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetAdminGroupsState.success:
        setOpenBackdropLoading(false);
        break;
      case GetAdminGroupsState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getAdminGroupsState]);

  useEffect(() => {
    switch (getAdminUserState.status) {
      case GetAdminUserState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetAdminUserState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetAdminUserState.success:
        setOpenBackdropLoading(false);
        break;
      case GetAdminUserState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getAdminUserState]);

  useEffect(() => {
    switch (createAdminUserState.status) {
      case CreateAdminUserState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CreateAdminUserState.initial:
        setOpenBackdropLoading(false);
        break;
      case CreateAdminUserState.success:
        showAlert(setSuccessAlert, createAdminUserState.message);
        setOpenBackdropLoading(false);
        break;
      case CreateAdminUserState.fail:
        showAlert(setFailsAlert, createAdminUserState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [createAdminUserState]);

  useEffect(() => {
    switch (getAdminUsersState.status) {
      case GetAdminUsersState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetAdminUsersState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetAdminUsersState.success:
        setOpenBackdropLoading(false);
        break;
      case GetAdminUsersState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getAdminUsersState]);

  useEffect(() => {
    switch (getAdminPopclubRedeemState.status) {
      case GetAdminPopclubRedeemState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetAdminPopclubRedeemState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetAdminPopclubRedeemState.success:
        setOpenBackdropLoading(false);
        break;
      case GetAdminPopclubRedeemState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getAdminPopclubRedeemState]);

  useEffect(() => {
    switch (loginAdminState.status) {
      case LoginAdminState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case LoginAdminState.initial:
        setOpenBackdropLoading(false);
        break;
      case LoginAdminState.success:
        showAlert(setSuccessAlert, loginAdminState.message);
        setOpenBackdropLoading(false);
        break;
      case LoginAdminState.fail:
        showAlert(setFailsAlert, loginAdminState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [loginAdminState]);

  useEffect(() => {
    switch (getAdminShopOrderState.status) {
      case GetAdminShopOrderState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetAdminShopOrderState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetAdminShopOrderState.success:
        setOpenBackdropLoading(false);
        break;
      case GetAdminShopOrderState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getAdminShopOrderState]);

  useEffect(() => {
    switch (getAdminShopOrdersState.status) {
      case GetAdminShopOrdersState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetAdminShopOrdersState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetAdminShopOrdersState.success:
        setOpenBackdropLoading(false);
        break;
      case GetAdminShopOrdersState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getAdminShopOrdersState]);

  useEffect(() => {
    switch (getRedeemState.status) {
      case GetRedeemState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetRedeemState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetRedeemState.success:
        setOpenBackdropLoading(false);
        break;
      case GetRedeemState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getRedeemState]);

  useEffect(() => {
    switch (getDealProductVariantsState.status) {
      case GetDealProductVariantsState.inProgress:
        setOpenBackdropPopClubLoading(true);
        break;
      case GetDealProductVariantsState.initial:
        setOpenBackdropPopClubLoading(false);
        break;
      case GetDealProductVariantsState.success:
        setOpenBackdropPopClubLoading(false);
        break;
      case GetDealProductVariantsState.fail:
        setOpenBackdropPopClubLoading(false);
        break;
    }
  }, [getDealProductVariantsState]);

  useEffect(() => {
    switch (getDealState.status) {
      case GetDealState.inProgress:
        setOpenBackdropPopClubLoading(true);
        break;
      case GetDealState.initial:
        setOpenBackdropPopClubLoading(false);
        break;
      case GetDealState.success:
        setOpenBackdropPopClubLoading(false);
        break;
      case GetDealState.fail:
        setOpenBackdropPopClubLoading(false);
        break;
    }
  }, [getDealState]);

  useEffect(() => {
    switch (forgotPasswordNewPasswordOTP.status) {
      case ForgotPasswordNewPasswordState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case ForgotPasswordNewPasswordState.initial:
        setOpenBackdropLoading(false);
        break;
      case ForgotPasswordNewPasswordState.success:
        showAlert(setSuccessAlert, forgotPasswordNewPasswordOTP.message);
        setOpenBackdropLoading(false);
        break;
      case ForgotPasswordNewPasswordState.fail:
        showAlert(setFailsAlert, forgotPasswordNewPasswordOTP.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [forgotPasswordNewPasswordOTP]);

  useEffect(() => {
    switch (forgotPasswordValidateOTP.status) {
      case ForgotPasswordValidateOTPState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case ForgotPasswordValidateOTPState.initial:
        setOpenBackdropLoading(false);
        break;
      case ForgotPasswordValidateOTPState.success:
        showAlert(setSuccessAlert, forgotPasswordValidateOTP.message);
        setOpenBackdropLoading(false);
        break;
      case ForgotPasswordValidateOTPState.fail:
        showAlert(setFailsAlert, forgotPasswordValidateOTP.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [forgotPasswordValidateOTP]);

  useEffect(() => {
    switch (forgotPasswordGenerateOTP.status) {
      case ForgotPasswordGenerateOTPState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case ForgotPasswordGenerateOTPState.initial:
        setOpenBackdropLoading(false);
        break;
      case ForgotPasswordGenerateOTPState.success:
        showAlert(setSuccessAlert, forgotPasswordGenerateOTP.message);
        setOpenBackdropLoading(false);
        break;
      case ForgotPasswordGenerateOTPState.fail:
        showAlert(setFailsAlert, forgotPasswordGenerateOTP.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [forgotPasswordGenerateOTP]);

  useEffect(() => {
    switch (signUpMobileUserState.status) {
      case SignUpMobileUserState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case SignUpMobileUserState.initial:
        setOpenBackdropLoading(false);
        break;
      case SignUpMobileUserState.success:
        SweetAlert.fire({
          title: "Account Registered!",
          text: signUpMobileUserState.message,
          icon: "success",
          background: "#22201A",
          color: "white",
        });
        setOpenBackdropLoading(false);
        break;
      case SignUpMobileUserState.fail:
        SweetAlert.fire({
          title: "Oops...",
          text: signUpMobileUserState.message,
          icon: "error",
          background: "#22201A",
          color: "white",
        });
        setOpenBackdropLoading(false);
        break;
    }
  }, [signUpMobileUserState]);

  useEffect(() => {
    switch (redeemDealState.status) {
      case RedeemDealState.inProgress:
        setOpenBackdropPopClubLoading(true);
        break;
      case RedeemDealState.initial:
        setOpenBackdropPopClubLoading(false);
        break;
      case RedeemDealState.success:
        setOpenBackdropPopClubLoading(false);
        break;
      case RedeemDealState.fail:
        setOpenBackdropPopClubLoading(false);
        break;
    }
  }, [redeemDealState]);

  useEffect(() => {
    switch (setSnacksDeliveredStoreAndAddress.status) {
      case SetSnacksDeliveredStoreAndAddressState.inProgress:
        setOpenBackdropPopClubLoading(true);
        break;
      case SetSnacksDeliveredStoreAndAddressState.initial:
        setOpenBackdropPopClubLoading(false);
        break;
      case SetSnacksDeliveredStoreAndAddressState.success:
        setOpenBackdropPopClubLoading(false);
        break;
      case SetSnacksDeliveredStoreAndAddressState.fail:
        setOpenBackdropPopClubLoading(false);
        break;
    }
  }, [setSnacksDeliveredStoreAndAddress, dispatch]);

  useEffect(() => {
    switch (getDealsState.status) {
      case GetDealsState.inProgress:
        setOpenBackdropPopClubLoading(true);
        break;
      case GetDealsState.initial:
        setOpenBackdropPopClubLoading(false);
        break;
      case GetDealsState.success:
        setOpenBackdropPopClubLoading(false);
        break;
      case GetDealsState.fail:
        setOpenBackdropPopClubLoading(false);
        break;
    }
  }, [getDealsState]);

  useEffect(() => {
    switch (getSnacksDeliveredAvailableStoresState.status) {
      case GetSnacksDeliveredAvailableStoresState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetSnacksDeliveredAvailableStoresState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetSnacksDeliveredAvailableStoresState.success:
        setOpenBackdropLoading(false);
        break;
      case GetSnacksDeliveredAvailableStoresState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getSnacksDeliveredAvailableStoresState]);

  useEffect(() => {
    switch (signInMobileUserState.status) {
      case SignInMobileUserState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case SignInMobileUserState.initial:
        setOpenBackdropLoading(false);
        break;
      case SignInMobileUserState.success:
        showAlert(setSuccessAlert, signInMobileUserState.message);
        setOpenBackdropLoading(false);
        break;
      case SignInMobileUserState.fail:
        showAlert(setFailsAlert, signInMobileUserState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [signInMobileUserState]);

  useEffect(() => {
    switch (cateringCheckoutOrdersState.status) {
      case CateringCheckoutOrdersState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CateringCheckoutOrdersState.initial:
        setOpenBackdropLoading(false);
        break;
      case CateringCheckoutOrdersState.success:
        showAlert(setSuccessAlert, cateringCheckoutOrdersState.message);
        setOpenBackdropLoading(false);
        break;
      case CateringCheckoutOrdersState.fail:
        showAlert(setFailsAlert, cateringCheckoutOrdersState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [cateringCheckoutOrdersState]);

  useEffect(() => {
    switch (checkoutOrdersState.status) {
      case CheckoutOrdersState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CheckoutOrdersState.initial:
        setOpenBackdropLoading(false);
        break;
      case CheckoutOrdersState.success:
        showAlert(setSuccessAlert, checkoutOrdersState.message);
        setOpenBackdropLoading(false);
        break;
      case CheckoutOrdersState.fail:
        showAlert(setFailsAlert, checkoutOrdersState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [checkoutOrdersState]);

  useEffect(() => {
    switch (popSnackBarState.status) {
      case PopSnackBarState.success:
        if (popSnackBarState.data.severity === "success")
          showAlert(setSuccessAlert, popSnackBarState.data.message);
        else if (popSnackBarState.data.severity === "error")
          showAlert(setFailsAlert, popSnackBarState.data.message);

        dispatch(popOutSnackBar());
        break;
    }
  }, [dispatch, popSnackBarState]);

  useEffect(() => {
    switch (getStoresAvailableCateringState.status) {
      case GetStoresAvailableCateringState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetStoresAvailableCateringState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetStoresAvailableCateringState.success:
        setOpenBackdropLoading(false);
        break;
      case GetStoresAvailableCateringState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getStoresAvailableCateringState]);

  useEffect(() => {
    switch (updateContactState.status) {
      case UpdateContactState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UpdateContactState.initial:
        setOpenBackdropLoading(false);
        break;
      case UpdateContactState.success:
        showAlert(setSuccessAlert, updateContactState.message);
        setOpenBackdropLoading(false);
        break;
      case UpdateContactState.fail:
        showAlert(setFailsAlert, updateContactState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [updateContactState]);

  useEffect(() => {
    switch (deleteContactState.status) {
      case DeleteContactState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case DeleteContactState.initial:
        setOpenBackdropLoading(false);
        break;
      case DeleteContactState.success:
        showAlert(setSuccessAlert, deleteContactState.message);
        setOpenBackdropLoading(false);
        break;
      case DeleteContactState.fail:
        showAlert(setFailsAlert, deleteContactState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [deleteContactState]);

  useEffect(() => {
    switch (addContactState.status) {
      case AddContactState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AddContactState.initial:
        setOpenBackdropLoading(false);
        break;
      case AddContactState.success:
        showAlert(setSuccessAlert, addContactState.message);
        setOpenBackdropLoading(false);
        break;
      case AddContactState.fail:
        showAlert(setFailsAlert, addContactState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [addContactState]);

  useEffect(() => {
    switch (addContactState.status) {
      case AddContactState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AddContactState.initial:
        setOpenBackdropLoading(false);
        break;
      case AddContactState.success:
        showAlert(setSuccessAlert, addContactState.message);
        setOpenBackdropLoading(false);
        break;
      case AddContactState.fail:
        showAlert(setFailsAlert, addContactState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [addContactState]);

  useEffect(() => {
    switch (cateringUploadProofOfPaymentState.status) {
      case CateringUploadProofOfPaymentState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case CateringUploadProofOfPaymentState.initial:
        setOpenBackdropLoading(false);
        break;
      case CateringUploadProofOfPaymentState.success:
        showAlert(setSuccessAlert, cateringUploadProofOfPaymentState.message);
        setOpenBackdropLoading(false);
        break;
      case CateringUploadProofOfPaymentState.fail:
        showAlert(setFailsAlert, cateringUploadProofOfPaymentState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [cateringUploadProofOfPaymentState]);

  useEffect(() => {
    switch (uploadProofOfPaymentState.status) {
      case UploadProofOfPaymentState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UploadProofOfPaymentState.initial:
        setOpenBackdropLoading(false);
        break;
      case UploadProofOfPaymentState.success:
        showAlert(setSuccessAlert, uploadProofOfPaymentState.message);
        setOpenBackdropLoading(false);
        break;
      case UploadProofOfPaymentState.fail:
        showAlert(setFailsAlert, uploadProofOfPaymentState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [uploadProofOfPaymentState]);

  useEffect(() => {
    switch (uploadContractState.status) {
      case UploadContractState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case UploadContractState.initial:
        setOpenBackdropLoading(false);
        break;
      case UploadContractState.success:
        showAlert(setSuccessAlert, uploadContractState.message);
        setOpenBackdropLoading(false);
        break;
      case UploadContractState.fail:
        showAlert(setFailsAlert, uploadContractState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [uploadContractState]);

  useEffect(() => {
    switch (removeItemFromCartShopState.status) {
      case RemoveItemFromCartShopState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case RemoveItemFromCartShopState.initial:
        setOpenBackdropLoading(false);
        break;
      case RemoveItemFromCartShopState.success:
        showAlert(setSuccessAlert, removeItemFromCartShopState.message);
        setOpenBackdropLoading(false);
        break;
      case RemoveItemFromCartShopState.fail:
        showAlert(setFailsAlert, removeItemFromCartShopState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [removeItemFromCartShopState]);

  useEffect(() => {
    switch (facebookLoginPointState.status) {
      case FacebookLoginPointState.success:
        setOpenBackdropLoading(false);
        break;
      case FacebookLoginPointState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [facebookLoginPointState]);

  useEffect(() => {
    switch (facebookLoginState.status) {
      case FacebookLoginState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case FacebookLoginState.initial:
        setOpenBackdropLoading(false);
        break;
      case FacebookLoginState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [facebookLoginState]);

  useEffect(() => {
    switch (getStoresAvailableSnackshopState.status) {
      case GetStoresAvailableSnackshopState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetStoresAvailableSnackshopState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetStoresAvailableSnackshopState.success:
        setOpenBackdropLoading(false);
        break;
      case GetStoresAvailableSnackshopState.fail:
        setOpenBackdropLoading(false);
        break;
    }
  }, [getStoresAvailableSnackshopState]);

  useEffect(() => {
    switch (getCategoryProductsState.status) {
      case GetCategoryProductsState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetCategoryProductsState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetCategoryProductsState.success:
        setOpenBackdropLoading(false);
        break;
      case GetCategoryProductsState.fail:
        showAlert(setFailsAlert, getCategoryProductsState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [getCategoryProductsState]);

  useEffect(() => {
    switch (getProductDetailsState.status) {
      case GetProductDetailsState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case GetProductDetailsState.initial:
        setOpenBackdropLoading(false);
        break;
      case GetProductDetailsState.success:
        setOpenBackdropLoading(false);
        break;
      case GetProductDetailsState.fail:
        showAlert(setFailsAlert, getProductDetailsState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [getProductDetailsState]);

  useEffect(() => {
    switch (addToCartShopState.status) {
      case AddToCartShopState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AddToCartShopState.initial:
        setOpenBackdropLoading(false);
        break;
      case AddToCartShopState.success:
        showAlert(setSuccessAlert, addToCartShopState.message);
        setOpenBackdropLoading(false);
        break;
      case AddToCartShopState.fail:
        showAlert(setFailsAlert, addToCartShopState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [addToCartShopState]);

  useEffect(() => {
    switch (addToCartCateringState.status) {
      case AddToCartCateringState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case AddToCartCateringState.initial:
        setOpenBackdropLoading(false);
        break;
      case AddToCartCateringState.success:
        showAlert(setSuccessAlert, addToCartCateringState.message);
        setOpenBackdropLoading(false);
        break;
      case AddToCartCateringState.fail:
        showAlert(setFailsAlert, addToCartCateringState.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [addToCartCateringState]);

  useEffect(() => {
    switch (editCartProduct.status) {
      case EditCartItemState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case EditCartItemState.initial:
        setOpenBackdropLoading(false);
        break;
      case EditCartItemState.success:
        showAlert(setSuccessAlert, editCartProduct.message);
        setOpenBackdropLoading(false);
        break;
      case EditCartItemState.fail:
        showAlert(setFailsAlert, editCartProduct.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [editCartProduct]);

  useEffect(() => {
    switch (formListStates.status) {
      case formListState.inProgress:
        setOpenBackdropLoading(true);
        break;
      case formListState.initial:
        setOpenBackdropLoading(false);
        break;
      case formListState.success:
        showAlert(setSuccessAlert, formListStates.message);
        setOpenBackdropLoading(false);
        break;
      case formListState.fail:
        showAlert(setFailsAlert, formListStates.message);
        setOpenBackdropLoading(false);
        break;
    }
  }, [formListStates]);

  return (
    <>
      <Outlet />
      <SnackbarAlert
        open={successAlert.status}
        severity="success"
        message={successAlert.message}
      />
      <SnackbarAlert
        open={failsAlert.status}
        severity="error"
        message={failsAlert.message}
      />
      <BackdropLoading open={openBackdropLoading} />
      <BackdropLoadingPopClub open={openBackdropPopClubLoading} />
    </>
  );
}

function showAlert(
  toggleStateAction: Dispatch<
    SetStateAction<{ status: boolean; message?: string | undefined }>
  >,
  message: string
) {
  toggleStateAction({
    status: true,
    message: message,
  });

  setTimeout(() => {
    toggleStateAction({
      status: false,
      message: message,
    });
  }, 3000);
}
